<template>
  <div class="create_page" @click="handleClickOutside">
    <div class="css3 questionnaire_box">
      <div class="box-sizing add_control">
        <div class="add_control_position add_control_position_new">
          <h6 class="title">添加控件</h6>
          <div class="el-scrollbar">
            <div class="el-scrollbar__wrap el-scrollbar__wrap--hidden-default">
              <div class="el-scrollbar__div">
                <div class="add_btn_list">
                  <div
                    v-for="(item, index) in components"
                    :data-type="item.type"
                    :key="index"
                  >
                    <div
                      class="add_title"
                      v-if="item.type === 1 || item.type === 14"
                    > 
                      <p>{{ item.type === 1 ? "基础题型" : "常用信息" }}</p>
                      <div
                        v-if="item.type === 1"
                        style="
                          margin-right: 20px;
                          color: #3a60ff;
                          cursor: pointer;
                        "
                        @click.stop="handleImportClick"
                      >
                        题库导入
                      </div>
                    </div>

                    <div
                      class="component-item css3 box-sizing btn_item cy_picture_hover"
                      @click.stop="handleComponentClick(item, index)"
                    >
                      <div
                        class="content"
                        style="display: flex; height: 100%; align-items: center"
                      >
                        <img
                          v-if="item.type === 1"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon110.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 1"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon111.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 2"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon120.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 2"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon121.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 3"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon220.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 3"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon221.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 4"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon230.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 4"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon231.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 5"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon130.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 5"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon131.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 6"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon350.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 6"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon351.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 7"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon440.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 7"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon441.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 8"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon450.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 8"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon451.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 9"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon410.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 9"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon411.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 10"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon310.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 10"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon311.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 11"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon210.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 11"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon211.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 12"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon12.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 12"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon13.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 13"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon320.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 13"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon321.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 23"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon540.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 23"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon541.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 14"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon460.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 14"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon461.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 15"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon470.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 15"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon471.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 16"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon480.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 16"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon481.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 17"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon490.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 17"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon491.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 18"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon500.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 18"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon501.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 19"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon510.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 19"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon511.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 20"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon520.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 20"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon521.svg"
                          alt=""
                        />

                        <img
                          v-if="item.type === 21"
                          class="colourless"
                          src="@/assets/images/add_icon/add_btn_icon530.svg"
                          alt=""
                        />
                        <img
                          v-if="item.type === 21"
                          class="color"
                          src="@/assets/images/add_icon/add_btn_icon531.svg"
                          alt=""
                        />
						
						<img
						  v-if="item.type === 24"
						  class="colourless"
						  src="@/assets/images/add_icon/add_btn_icon532.svg"
						  alt=""
						/>
						<img
						  v-if="item.type === 24"
						  class="color"
						  src="@/assets/images/add_icon/add_btn_icon533.svg"
						  alt=""
						/>
						
						<img
						  v-if="item.type === 25"
						  class="colourless"
						  src="@/assets/images/add_icon/add_btn_icon534.svg"
						  alt=""
						/>
						<img
						  v-if="item.type === 25"
						  class="color"
						  src="@/assets/images/add_icon/add_btn_icon535.svg"
						  alt=""
						/>
						
						<img
						  v-if="item.type === 26"
						  class="colourless"
						  src="@/assets/images/add_icon/add_btn_icon536.svg"
						  alt=""
						/>
						<img
						  v-if="item.type === 26"
						  class="color"
						  src="@/assets/images/add_icon/add_btn_icon537.svg"
						  alt=""
						/>
						
						<img
						  v-if="item.type === 27"
						  class="colourless"
						  src="@/assets/images/add_icon/add_btn_icon538.svg"
						  alt=""
						/>
						<img
						  v-if="item.type === 27"
						  class="color"
						  src="@/assets/images/add_icon/add_btn_icon539.svg"
						  alt=""
						/>

						<img
						  v-if="item.type === 29"
						  class="colourless"
						  src="@/assets/images/add_icon/add_btn_icon550.svg"
						  alt=""
						/>
						<img
						  v-if="item.type === 29"
						  class="color"
						  src="@/assets/images/add_icon/add_btn_icon551.svg"
						  alt=""
						/>
						
						<img
						  v-if="item.type === 30"
						  class="colourless"
						  src="@/assets/images/add_icon/add_btn_icon552.svg"
						  alt=""
						/>
						<img
						  v-if="item.type === 30"
						  class="color"
						  src="@/assets/images/add_icon/add_btn_icon553.svg"
						  alt=""
						/>
						
						<img
						  v-if="item.type === 31"
						  class="colourless"
						  src="@/assets/images/add_icon/add_btn_icon554.svg"
						  alt=""
						/>
						<img
						  v-if="item.type === 31"
						  class="color"
						  src="@/assets/images/add_icon/add_btn_icon555.svg"
						  alt=""
						/>
						
						<img
						  v-if="item.type === 32"
						  class="colourless"
						  src="@/assets/images/add_icon/add_btn_icon556.svg"
						  alt=""
						/>
						<img
						  v-if="item.type === 32"
						  class="color"
						  src="@/assets/images/add_icon/add_btn_icon557.svg"
						  alt=""
						/>

                        <span>{{ item.name }}</span>
                      </div>
                      <el-popover placement="right-start" trigger="hover">
                        <div class="cy_prediv_hover">
                          <img
                            v-if="item.type === 1"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn0.svg"
                            alt=""
                          />
                          <img
                            v-if="item.type === 2"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn1.svg"
                            alt=""
                          />
                          <img
                            v-if="item.type === 3"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn4.svg"
                            alt=""
                          />
                          <img
                            v-if="item.type === 4"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn5.svg"
                            alt=""
                          />
                          <img
                            v-if="item.type === 5"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn2.svg"
                            alt=""
                          />
                          <img
                            v-if="item.type === 6"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn54.png"
                            alt=""
                          />
                          <img
                            v-if="item.type === 7"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn59.png"
                            alt=""
                          />
                          <img
                            v-if="item.type === 8"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn11.png"
                            alt=""
                          />
                          <img
                            v-if="item.type === 9"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn8.svg"
                            alt=""
                          />
                          <img
                            v-if="item.type === 10"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn6.svg"
                            alt=""
                          />
                          <img
                            v-if="item.type === 11"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn3.svg"
                            alt=""
                          />
                          <img
                            v-if="item.type === 12"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocnQZ.png"
                            alt=""
                          />
                          <img
                            v-if="item.type === 13"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn7.svg"
                            alt=""
                          />
                          <img
                            v-if="item.type === 23"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn60.png"
                            alt=""
                            style="width: 315px;"
                          />
                          <img
                            v-if="item.type === 14"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn46.png"
                            alt=""
                          />
                          <img
                            v-if="item.type === 15"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn47.png"
                            alt=""
                          />
                          <img
                            v-if="item.type === 16"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn48.png"
                            alt=""
                          />
                          <img
                            v-if="item.type === 17"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn49.png"
                            alt=""
                          />
                          <img
                            v-if="item.type === 18"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn50.png"
                            alt=""
                          />
                          <img
                            v-if="item.type === 19"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn51.png"
                            alt=""
                          />
                          <img
                            v-if="item.type === 20"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn52.png"
                            alt=""
                          />
                          <img
                            v-if="item.type === 21"
                            class="cy_btn_i draggable_item"
                            src="@/assets/images/add_icon/hover-iocn53.png"
                            alt=""
                          />
						  <img
						    v-if="item.type === 24"
						    class="cy_btn_i draggable_item"
						    src="@/assets/images/add_icon/hover-iocn61.png"
						    alt=""
						  />
						  <img
						    v-if="item.type === 25"
						    class="cy_btn_i draggable_item"
						    src="@/assets/images/add_icon/hover-iocn62.png"
						    alt=""
						  />
						  <img
						    v-if="item.type === 26"
						    class="cy_btn_i draggable_item"
						    src="@/assets/images/add_icon/hover-iocn63.png"
						    alt=""
						  />
						  <img
						    v-if="item.type === 27"
						    class="cy_btn_i draggable_item"
						    src="@/assets/images/add_icon/hover-iocn64.png"
						    alt=""
						  />
						  <img
						    v-if="item.type === 29"
						    class="cy_btn_i draggable_item"
						    src="@/assets/images/add_icon/hover-iocn65.png"
						    alt=""
						  />
						  <img
						    v-if="item.type === 30"
						    class="cy_btn_i draggable_item"
						    src="@/assets/images/add_icon/hover-iocn66.png"
						    alt=""
						  />
						  <img
						    v-if="item.type === 31"
						    class="cy_btn_i draggable_item"
						    src="@/assets/images/add_icon/hover-iocn67.png"
						    alt=""
						  />
						  <img
						    v-if="item.type === 32"
						    class="cy_btn_i draggable_item"
						    src="@/assets/images/add_icon/hover-iocn68.png"
						    alt=""
						  />
                        </div>
                        <div slot="reference" class="oezo_add_tips">
                          <img
                            class="oezo_add_tips0"
                            src="@/assets/images/add_icon/icon_tips.svg"
                            alt=""
                          />
                          <img
                            class="oezo_add_tips1"
                            src="@/assets/images/add_icon/icon_tips0.svg"
                            alt=""
                          />
                        </div>
                      </el-popover>
                      <div class="cy_add_chosen_here">添加到此处</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-sizing add_content" style="width: 630px; overflow-y: auto; height: 100%; position: relative; padding-bottom: 80px;">
        <div class="create_head">
          <h6 style="font-size: 18px; font-weight: bold; color: #4c4c4c; width: 100%; text-align: left;">
            问卷名称
          </h6>
          <div style="width: 100%; border: 1px solid #E8E8E8; border-radius: 4px; margin-top: 15px;" :style="{ borderColor: nameFocus ? '#409EFF' : '#E8E8E8' }">
            <input
                ref="titleInput"
                type="text"
                v-model="dataObj.questionnaireName"
                @blur="nameFocus = false"
                @focus="nameFocus = true"
                autocomplete="off"
                placeholder="问卷标题"
                maxlength="20"
                class="el-input__inner"
                style="width: 100%; font-size: 14px; border: none;"
              />
          </div>
          <div class="intro-container">
            <el-input
              type="textarea"
              :maxlength="200"
              resize="none"
              :autosize="{ minRows: 4, maxRows: 6 }"
              placeholder="感谢您抽出宝贵时间，你的回答意义重大!"
              v-model="dataObj.questionnaireDescribe">
            </el-input>
          </div>
          
          <div class="upload-container">
            <div v-for="(fileItem, fileIndex) in infoFileList" :key="fileIndex">
              <div class="upload-option">
                <img
                  src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
                  lazy-load
                  class="image-up"
                  @click.stop="handleUploadUp(fileIndex)"
                />
                <img
                  src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
                  lazy-load
                  class="image-down"
                  @click.stop="handleUploadDown(fileIndex)"
                />
                <img
                  src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
                  lazy-load
                  class="image-delete"
                  @click.stop="handleUploadDelete(fileIndex)"
                />
              </div>
              <!-- 单张图片 -->
              <div v-if="fileItem.type === 0" style="margin-top: 10px">
                <div v-if="fileItem.urls.length == 0" class="upload-big" @click.stop="handleSingleUploadImage(fileIndex)">
                  <img
                    src="https://ossfastmake.mustke.com/qrCode/tupian/1741830806500.png"
                    mode=""
                    style="width: 100%; height: 100%"
                  />
                </div>
                <div v-else class="big-image">
                  <img
                  :src="fileItem.urls[0].url"
                  mode=""
                  style="width: 100%; height: 100%" />
                  <img src="@/assets/images/guanbi.png" class="delete-image" @click.stop="handleSingleDelete(fileIndex)"></img>
                </div>
              </div>
              <!-- 多张图片 -->
              <div
                v-if="fileItem.type === 1"
                style="
                  display: grid;
                  grid-template-columns: repeat(3, 1fr);
                  gap: 20px;
                  margin-top: 10px;
                "
              >
                <div
                  v-for="(file, idx) in fileItem.urls"
                  :key="file.url"
                  class="small-image"
                >
                  <img
                    :src="file.url"
                    mode=""
                    style="width: 100%; height: 100%"
                  />
                  <img src="@/assets/images/guanbi.png" class="delete-image" @click.stop="handleMultipleDelete(fileIndex, idx)"></img>
                </div>
                <div v-if="fileItem.urls.length < 9" class="upload-small" @click.stop="handleMultipleUploadImage(fileIndex)">
                  <img
                    src="https://ossfastmake.mustke.com/qrCode/tupian/1741830806500.png"
                    mode=""
                    style="width: 100%; height: 100%"
                  />
                </div>
              </div>
              <!-- 上传视频 -->
              <div v-if="fileItem.type === 2" style="margin-top: 10px">
                <div v-if="fileItem.urls.length == 0" class="upload-big" @click.stop="handleVideoUploadClick(fileIndex)">
                  <img
                    src="https://ossfastmake.mustke.com/qrCode/tupian/1741830806500.png"
                    mode=""
                    style="width: 100%; height: 100%"
                  />
                </div>
                <div v-else class="big-image">
                  <video :src="fileItem.urls[0].url" controls></video>
                  <img src="@/assets/images/guanbi.png" class="delete-image" @click.stop="handleVideoDelete(fileIndex)"></img>
                </div>
              </div>
            </div>
            
            
            <div class="upload-btns">
              <div @click.stop="handleUploadAdd(0)">
                <img
                  src="@/assets/images/questionnaire/single_image.png"
                  alt=""
                  style="width: 25px; height: 25px"
                />
                <span>单张图片</span>
              </div>
              <div @click.stop="handleUploadAdd(1)">
                <img
                  src="@/assets/images/questionnaire/multiple_image.png"
                  alt=""
                  style="width: 25px; height: 25px"
                />
                <span>多张图片</span>
              </div>
              <div @click.stop="handleUploadAdd(2)">
                <img
                  src="@/assets/images/questionnaire/single_video.png"
                  alt=""
                  style="width: 25px; height: 25px"
                />
                <span>上传视频</span>
              </div>
            </div>
          </div>
        </div>
        <div class="subject_list">
          <div class="noData" v-if="addQuestionsList.length <= 0">
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1749797144252.png"
              alt=""
            />
            <div class="text">请点击左侧题型</div>
          </div>

          <div v-for="(item, index) in addQuestionsList" :key="index" @click.stop="">
            <div class="item" v-if="item.type == QuestionType.SCQ">
              <div v-if="item.status === '0'">
                <QuestionEditSCQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  :allDatas="addQuestionsList"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditSCQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewSCQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewSCQ>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.MCQ">
              <div v-if="item.status === '0'">
                <QuestionEditMCQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditMCQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewMCQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewMCQ>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.SBQ">
              <div v-if="item.status === '0'">
                <QuestionEditSBQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditSBQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewSBQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewSBQ>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.MBQ">
              <div v-if="item.status === '0'">
                <QuestionEditMBQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditMBQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewMBQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewMBQ>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.DLQ">
              <div v-if="item.status === '0'">
                <QuestionEditDLQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditDLQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewDLQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewDLQ>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.NPS">
              <div v-if="item.status === '0'">
                <QuestionEditNPS
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditNPS>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewNPS
                  :params="{ data: item, index: index }"
                ></QuestionPreviewNPS>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.QA">
              <div v-if="item.status === '0'">
                <QuestionEditQA
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditQA>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewQA
                  :params="{ data: item, index: index }"
                ></QuestionPreviewQA>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.SRQ">
              <div v-if="item.status === '0'">
                <QuestionEditSRQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditSRQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewSRQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewSRQ>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.VOTE">
              <div v-if="item.status === '0'">
                <QuestionEditVote
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditVote>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewVote
                  :params="{ data: item, index: index }"
                ></QuestionPreviewVote>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.SORT">
              <div v-if="item.status === '0'">
                <QuestionEditSort
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditSort>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewSort
                  :params="{ data: item, index: index }"
                ></QuestionPreviewSort>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.SCORE">
              <div v-if="item.status === '0'">
                <QuestionEditScore
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditScore>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewScore
                  :params="{ data: item, index: index }"
                ></QuestionPreviewScore>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.WRQ">
              <div v-if="item.status === '0'">
                <QuestionEditWRQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditWRQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewWRQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewWRQ>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.REMARK">
              <div v-if="item.status === '0'">
                <QuestionEditRemark
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditRemark>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewRemark
                  :params="{ data: item, index: index }"
                ></QuestionPreviewRemark>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.NAME">
              <div v-if="item.status === '0'">
                <QuestionEditName
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditName>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewName
                  :params="{ data: item, index: index }"
                ></QuestionPreviewName>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.GENDER">
              <div v-if="item.status === '0'">
                <QuestionEditGender
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditGender>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewGender
                  :params="{ data: item, index: index }"
                ></QuestionPreviewGender>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.AGE">
              <div v-if="item.status === '0'">
                <QuestionEditAge
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditAge>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewAge
                  :params="{ data: item, index: index }"
                ></QuestionPreviewAge>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.TEL">
              <div v-if="item.status === '0'">
                <QuestionEditTel
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditTel>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewTel
                  :params="{ data: item, index: index }"
                ></QuestionPreviewTel>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.EMAIL">
              <div v-if="item.status === '0'">
                <QuestionEditEmail
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditEmail>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewEmail
                  :params="{ data: item, index: index }"
                ></QuestionPreviewEmail>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.DATE">
              <div v-if="item.status === '0'">
                <QuestionEditDate
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditDate>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewDate
                  :params="{ data: item, index: index }"
                ></QuestionPreviewDate>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.TIME">
              <div v-if="item.status === '0'">
                <QuestionEditTime
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditTime>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewTime
                  :params="{ data: item, index: index }"
                ></QuestionPreviewTime>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.ADDR">
              <div v-if="item.status === '0'">
                <QuestionEditAddress
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditAddress>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewAddress
                  :params="{ data: item, index: index }"
                ></QuestionPreviewAddress>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.IMAGE">
              <div v-if="item.status === '0'">
                <QuestionEditImage
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditImage>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewImage
                  :params="{ data: item, index: index }"
                ></QuestionPreviewImage>
                <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
              </div>
            </div>
			
			
			<div class="item" v-if="item.type == QuestionType.MaxDiff">
			  <div v-if="item.status === '0'">
				<QuestionEditMaxDiff
				  :params="item"
				  :index="index"
				  :uuid="uuid"
				  @save="saveQuestionClick"
				  @operate="handleOperateClick"
				  @update="updateQuestionClick"
				  @cancel="cancelQuestionClick"
				  @logic="logicSettingClick(item, index)"
				></QuestionEditMaxDiff>
			  </div>
			  <div v-else style="position: relative">
			    <QuestionPreviewMaxDiff
			      :params="{ data: item, index: index }"
			    ></QuestionPreviewMaxDiff>
			    <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
			  </div>
			</div>
			<div class="item" v-if="item.type == QuestionType.UploadFile">
			  <div v-if="item.status === '0'">
				<QuestionEditUploadFile
				  :params="item"
				  :index="index"
				  :uuid="uuid"
				  @save="saveQuestionClick"
				  @operate="handleOperateClick"
				  @update="updateQuestionClick"
				  @cancel="cancelQuestionClick"
				  @logic="logicSettingClick(item, index)"
				></QuestionEditUploadFile>
			  </div>
			  <div v-else style="position: relative">
			    <QuestionPreviewUploadFile
			      :params="{ data: item, index: index }"
			    ></QuestionPreviewUploadFile>
			    <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
			  </div>
			</div>
			<div class="item" v-if="item.type == QuestionType.DownloadFile">
			  <div v-if="item.status === '0'">
				<QuestionEditDownloadFile
				  :params="item"
				  :index="index"
				  :uuid="uuid"
				  @save="saveQuestionClick"
				  @operate="handleOperateClick"
				  @update="updateQuestionClick"
				  @cancel="cancelQuestionClick"
				  @logic="logicSettingClick(item, index)"
				></QuestionEditDownloadFile>
			  </div>
			  <div v-else style="position: relative">
			    <QuestionPreviewDownloadFile
			      :params="{ data: item, index: index }"
			    ></QuestionPreviewDownloadFile>
			    <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
			  </div>
			</div>
			<div class="item" v-if="item.type == QuestionType.CASCADER">
			  <div v-if="item.status === '0'">
				<QuestionEditCASCADER
				  :params="item"
				  :index="index"
				  :uuid="uuid"
				  @save="saveQuestionClick"
				  @operate="handleOperateClick"
				  @update="updateQuestionClick"
				  @cancel="cancelQuestionClick"
				  @logic="logicSettingClick(item, index)"
				></QuestionEditCASCADER>
			  </div>
			  <div v-else style="position: relative">
			    <QuestionPreviewCASCADER
			      :params="{ data: item, index: index }"
			    ></QuestionPreviewCASCADER>
			    <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
			  </div>
			</div>
			<div class="item" v-if="item.type == QuestionType.BDQ">
			  <div v-if="item.status === '0'">
				<QuestionEditBDQ
				  :params="item"
				  :index="index"
				  :uuid="uuid"
				  @save="saveQuestionClick"
				  @operate="handleOperateClick"
				  @update="updateQuestionClick"
				  @cancel="cancelQuestionClick"
				  @logic="logicSettingClick(item, index)"
				></QuestionEditBDQ>
			  </div>
			  <div v-else style="position: relative">
			    <QuestionPreviewBDQ
			      :params="{ data: item, index: index }"
			    ></QuestionPreviewBDQ>
			    <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
			  </div>
			</div>
			<div class="item" v-if="item.type == QuestionType.IDQ">
			  <div v-if="item.status === '0'">
				<QuestionEditIDQ
				  :params="item"
				  :index="index"
				  :uuid="uuid"
				  @save="saveQuestionClick"
				  @operate="handleOperateClick"
				  @update="updateQuestionClick"
				  @cancel="cancelQuestionClick"
				  @logic="logicSettingClick(item, index)"
				></QuestionEditIDQ>
			  </div>
			  <div v-else style="position: relative">
			    <QuestionPreviewIDQ
			      :params="{ data: item, index: index }"
			    ></QuestionPreviewIDQ>
			    <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
			  </div>
			</div>
			<div class="item" v-if="item.type == QuestionType.ELQ">
			  <div v-if="item.status === '0'">
				<QuestionEditELQ
				  :params="item"
				  :index="index"
				  :uuid="uuid"
				  @save="saveQuestionClick"
				  @operate="handleOperateClick"
				  @update="updateQuestionClick"
				  @cancel="cancelQuestionClick"
				  @logic="logicSettingClick(item, index)"
				></QuestionEditELQ>
			  </div>
			  <div v-else style="position: relative">
			    <QuestionPreviewELQ
			      :params="{ data: item, index: index }"
			    ></QuestionPreviewELQ>
			    <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
			  </div>
			</div>
			<div class="item" v-if="item.type == QuestionType.WX">
			  <div v-if="item.status === '0'">
				<QuestionEditWX
				  :params="item"
				  :index="index"
				  :uuid="uuid"
				  @save="saveQuestionClick"
				  @operate="handleOperateClick"
				  @update="updateQuestionClick"
				  @cancel="cancelQuestionClick"
				  @logic="logicSettingClick(item, index)"
				></QuestionEditWX>
			  </div>
			  <div v-else style="position: relative">
			    <QuestionPreviewWX
			      :params="{ data: item, index: index }"
			    ></QuestionPreviewWX>
			    <div class="mask-div" @click.stop="handleMaskClick(index)"></div>
			  </div>
			</div>
			
          </div>
        </div>
        <div class="bottom" style="position: fixed; bottom: 10px; width: 630px; z-index: 1005;">
          <!-- <div>
            <div class="cy_text">
              <div class="cy_text_show">问卷到此结束，感谢您的参与！</div>
            </div>
          </div> -->
          <button
            type="button"
            class="el-button hold el-button--primary el-button--medium"
            @click.stop="createClick(0)"
            style="width: 132px; height: 40px; background: #ffffff; border: 1px solid #3a60ff; color: #3a60ff;"
          >
            <span>保存草稿</span>
          </button>
          <button
            type="button"
            class="el-button hold el-button--primary el-button--medium"
            @click.stop="createClick(1)"
            style="width: 132px; height: 40px; background: #3a60ff; border: 1px solid #3a60ff;"
          >
            <span>生成问卷</span>
          </button>
        </div>
      </div>
      <div class="box-sizing add_control">
        <div class="add_control_position add_control_position_new">
          <!-- <h6 class="title">题目设置</h6> -->
          <div class="el-scrollbar">
            <div class="el-scrollbar__wrap el-scrollbar__wrap--hidden-default">
              <div class="el-scrollbar__div">
                <div class="add_btn_list">
                  <div class="setting-item">
                    <div class="setting-item-left">
                      <div style="display: flex; align-items: center">
                        <div class="bar-view"></div>
                        <div class="setting-title">通用设置</div>
                      </div>
                    </div>
                    <div class="setting-item-right"></div>
                  </div>
                  <div class="switch-div">
                    <p>每人只能回答一次(仅限小程序生效)</p>
                    <el-switch
                      v-model="dataObj.ifOneChance"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :active-value="'1'"
                      :inactive-value="'0'"
                    >
                    </el-switch>
                  </div>
                  <div class="switch-div">
                    <p>仅创建人可分享</p>
                    <el-switch
                      v-model="dataObj.ifShare"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :active-value="'1'"
                      :inactive-value="'0'"
                    >
                    </el-switch>
                  </div>
                  <div class="switch-div">
                    <p>显示创建人信息</p>
                    <el-switch
                      v-model="dataObj.ifShowCreator"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :active-value="'1'"
                      :inactive-value="'0'"
                      @change="handleIfShowCreatorChange"
                    >
                    </el-switch>
                  </div>
                  <div v-if="dataObj.ifShowCreator == '1'" class="switch-div">
                    <p>发布人</p>
                    <el-input v-model="dataObj.creatorName" size="small" placeholder="请输入发布人" style="width: 120px;
                     font-size: 14px;"></el-input>
                  </div>
                  <div v-if="dataObj.ifShowCreator == '1'" class="switch-div">
                    <p>显示参加人数</p>
                    <el-switch
                      v-model="dataObj.ifShowParticipation"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :active-value="'1'"
                      :inactive-value="'0'"
                    >
                    </el-switch>
                  </div>
                  <!-- <div class="switch-div">
                    <p>显示创建时间</p>
                    <el-switch
                      v-model="dataObj.ifShowCreateTime"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :active-value="'1'"
                      :inactive-value="'0'"
                    >
                    </el-switch>
                  </div> -->
                  <!-- <div class="add_title">问卷开始结束时间</div> -->
                   <div class="setting-item" style="border-bottom: none">
                    <div class="setting-item-left">
                      <div style="display: flex; align-items: center">
                        <div class="bar-view"></div>
                        <div class="setting-title">问卷开始结束时间</div>
                      </div>
                    </div>
                    <div class="setting-item-right"></div>
                  </div>
                  <div class="block">
                    <span class="demonstration">是否设置问卷时间</span>
                    <div style="margin-top: 10px">
                      <el-radio v-model="dataObj.ifForever" :label="'0'"
                        >不限制</el-radio
                      >
                      <el-radio v-model="dataObj.ifForever" :label="'1'"
                        >限制时间</el-radio
                      >
                    </div>
                  </div>
                  <div v-if="dataObj.ifForever == '1'" class="block top">
                    <span class="demonstration top">开始时间</span>
                    <div class="top">
                      <el-date-picker
                        v-model="dataObj.startTime"
                        type="datetime"
                        placeholder="选择日期时间"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                  <div v-if="dataObj.ifForever == '1'" class="block top">
                    <span class="demonstration">结束时间</span>
                    <div class="top">
                      <el-date-picker
                        v-model="dataObj.endTime"
                        type="datetime"
                        placeholder="选择日期时间"
                      >
                      </el-date-picker>
                    </div>
                  </div>
	  
				  <div class="setting-item">
				    <div class="setting-item-left">
				      <div style="display: flex; align-items: center">
				        <div class="bar-view"></div>
				        <div class="setting-title">知情同意书设置</div>
				      </div>
				    </div>
				    <div class="setting-item-right">
				      <div
				        style="position: relative; z-index: 2"
				        :style="{
				          right: dataObj.consentRequired === '1' ? '120px' : '0',
				        }"
				      >
				      </div>
				      <div>
				        <el-switch
				          v-model="dataObj.consentRequired"
				          active-color="#13ce66"
                  inactive-color="#ff4949"
				          :active-value="'1'"
				          :inactive-value="'0'"
				        >
				        </el-switch>
				      </div>
				      <div
				        v-if="dataObj.consentRequired === '1'"
				        :style="{
				          opacity: dataObj.consentRequired === '1' ? '1' : '0',
				        }"
				        style="display: flex; align-items: center"
				        @click.stop="handleConsentRequired"
				      >
				        <div class="setting-link">设置</div>
				        <img
				          src="https://ossfastmake.mustke.com/qrCode/tupian/1737516961703.svg"
				          mode="heightFix"
				          style="height: 12px;"
				        />
				      </div>
				    </div>
				  </div>
				  
				  
				  
                  <!-- <button @click.stop="handleThemeSetting">主题设置</button> -->
                  <div class="setting-item">
                    <div class="setting-item-left">
                      <div style="display: flex; align-items: center">
                        <div class="bar-view"></div>
                        <div class="setting-title">主题设置</div>
                      </div>
                    </div>
                    <div class="setting-item-right">
                      <div style="position: relative; z-index: 2"></div>
                      <div
                        style="display: flex; align-items: center"
                        @click.stop="handleThemeSetting"
                      >
                        <div class="setting-link">
                          {{
                            dataObj.themeId === "" ||
                            dataObj.themeId === null ||
                            dataObj.themeId === undefined
                              ? "设置"
                              : themeData.mainTitle
                          }}
                        </div>
                        <img
                          src="https://ossfastmake.mustke.com/qrCode/tupian/1737516961703.svg"
                          mode="heightFix"
                          style="height: 12px;"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="setting-item">
                    <div class="setting-item-left">
                      <div style="display: flex; align-items: center">
                        <div class="bar-view"></div>
                        <div class="setting-title">封面设置</div>
                      </div>
                    </div>
                    <div class="setting-item-right">
                      <div
                        style="position: relative; z-index: 2"
                        :style="{
                          right: dataObj.ifFrontPage === '1' ? '120px' : '0',
                        }"
                      ></div>
                      <div>
                        <el-switch
                          v-model="dataObj.ifFrontPage"
                          active-color="#13ce66"
                      inactive-color="#ff4949"
                          :active-value="'1'"
                          :inactive-value="'0'"
                        >
                        </el-switch>
                      </div>
                      <div
                        v-if="dataObj.ifFrontPage === '1'"
                        :style="{
                          opacity: dataObj.ifFrontPage === '1' ? '1' : '0',
                        }"
                        style="display: flex; align-items: center"
                        @click.stop="handleCoverSetting"
                      >
                        <div class="setting-link">设置</div>
                        <img
                          src="https://ossfastmake.mustke.com/qrCode/tupian/1737516961703.svg"
                          mode="heightFix"
                          style="height: 12px;"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="setting-item">
                    <div class="setting-item-left">
                      <div style="display: flex; align-items: center">
                        <div class="bar-view"></div>
                        <div class="setting-title">独立登录</div>
                      </div>
                      <!-- <div
                          style="
                            width: 88px;
                            height: 32px;
                            line-height: 32px;
                            background: #9ab3ec;
                            border-radius: 16px;
                            font-size: 22px;
                            color: #ffffff;
                            text-align: center;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                          @click.stop="handleShowLogin"
                        >
                          演示
                          <div class="setting-icon"></div>
                        </div> -->
                    </div>
                    <div class="setting-item-right">
                      <div
                        style="position: relative; z-index: 2"
                        :style="{
                          right: dataObj.ifCustomLogin === '1' ? '120px' : '0',
                        }"
                      >
                        <!-- <up-switch v-model="dataObj.ifCustomLogin" size="20" activeColor="#59D27B" :activeValue="'1'"
                                   :inactiveValue="'0'" @click.native.stop></up-switch> -->
                      </div>
                      <div>
                        <el-switch
                          v-model="dataObj.ifCustomLogin"
                          active-color="#13ce66"
                          inactive-color="#ff4949"
                          :active-value="'1'"
                          :inactive-value="'0'"
                          @change="handleCustomLoginSwitch"
                        >
                        </el-switch>
                      </div>
                      <div
                        v-if="dataObj.ifCustomLogin === '1'"
                        :style="{
                          opacity: dataObj.ifCustomLogin === '1' ? '1' : '0',
                        }"
                        style="display: flex; align-items: center"
                        @click.stop="handleLoginSetting"
                      >
                        <div class="setting-link">设置</div>
                        <img
                          src="https://ossfastmake.mustke.com/qrCode/tupian/1737516961703.svg"
                          mode="heightFix"
                          style="height: 12px;"
                        />
                      </div>
                    </div>
                  </div>
				  
				  <div class="setting-item">
					<div class="setting-item-left">
					  <div style="display: flex; align-items: center">
						<div class="bar-view"></div>
						<div class="setting-title">分享图设置</div>
					  </div>
					</div>
					<div class="setting-item-right">
					  <div
						style="display: flex; align-items: center;"
						@click.stop="handleShareImage"
					  >
						<img :src="dataObj.shareImgUrl" style="margin-right: 10px; width: 37px; height: auto;"/>
						<div class="setting-link">更换</div>
					  </div>
					</div>
				  </div>
				  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="drawer-container">
      <el-drawer
        :visible.sync="showThemeSetting"
        :with-header="false"
        :size="500"
      >
        <div style="width: 500px; height: 100%; position: relative; background-color: #f8f8f8;">
          <div class="item-container">
            <div
              v-for="(item, index) in themeList"
              :key="index"
              style="
                width: 102px;
                height: 134px;
                box-sizing: border-box;
                margin-bottom: 15px;
                border-radius: 9px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                cursor: pointer;
              "
              @click.stop="selectThemeIndex = index"
            >
              <div
                style="
                  width: 100%;
                  height: 100%;
                  border-radius: 9px;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
                :style="{
                  backgroundImage: `linear-gradient(to bottom, ${item.startColor}, ${item.endColor})`,
                  border: `1px solid ${item.borderColor}`,
                }"
              >
                <div
                  style="
                    display: inline-block;
                    font-size: 18px;
                    font-weight: 700;
                    margin-top: 23px;
                  "
                  :style="{ color: `${item.mainColor}` }"
                >
                  {{ item.mainTitle }}
                </div>
                <div
                  style="
                    display: inline-block;
                    font-size: 14px;
                    font-weight: 400;
                    margin-top: 7px;
                    opacity: 0.7;
                  "
                  :style="{ color: `${item.subColor}` }"
                >
                  {{ item.subTitle }}
                </div>
                <div
                  style="
                    display: inline-block;
                    width: 69px;
                    height: 28px;
                    line-height: 28px;
                    font-size: 15px;
                    margin-top: 18px;
                    border-radius: 4px;
                    border: none;
                    text-align: center;
                  "
                  :style="{
                    border: `1px solid ${item.btnBorder}`,
                    backgroundColor: `${item.btnBg}`,
                    color: `${item.btnColor}`,
                  }"
                >
                  {{ item.btnText }}
                </div>
                <div
                  v-if="selectThemeIndex === index"
                  style="
                    position: absolute;
                    width: 102px;
                    height: 134px;
                    left: 0;
                    top: 0;
                    background-color: rgba(0, 0, 0, 0.56);
                    border-radius: 9px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <img
                    src="https://ossfastmake.mustke.com/qrCode/tupian/1747032457200.svg"
                    style="width: 28px; height: 28px; z-index: 10"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="btn-div">
            <div class="cancel" @click.stop="showThemeSetting = false">取消</div>
            <div class="confirm" @click.stop="themeSettingConfirmClick">保存</div>
          </div>
        </div>
      </el-drawer>
      <el-drawer
        :visible.sync="showLoginSetting"
        :with-header="false"
        :size="500"
      >
        <CustomLogin
          :list="dataObj.customLoginSettingList"
          @custom-login="handleCustomLoginChange"
          @custom-cancel="showLoginSetting = false"
        ></CustomLogin>
      </el-drawer>
      <el-drawer
        :visible.sync="showCoverSetting"
        :with-header="false"
        :size="500"
      >
        <QuestionStartAndEnd
          :dataObj="dataObj"
          @start-end="handleStartEndChange"
          @cancel="showCoverSetting = false"
        ></QuestionStartAndEnd>
      </el-drawer>
	  <el-drawer
	    :visible.sync="showConsentRequired"
	    :with-header="false"
	    :size="500"
	  >
		<ConsentRequiredDialog
			:content="dataObj.consentContent"
			@confirm="ConsentRequiredContent"
			@cancel="ConsentRequiredClose"
		></ConsentRequiredDialog>
	  </el-drawer>
	  <el-drawer
		:visible.sync="showShareImage"
		:with-header="false"
		:size="500"
		@opened="$refs.shareDialog.getList()"
	  >
		<ShareImageDialog
		  ref="shareDialog"
		  :dataObj="dataObj"
		  @confirm="ShareImageContent"
		  @cancel="ShareImageClose"
		/>
	  </el-drawer>
      <LibraryChooseDialog
        :showDialog.sync="showDialog"
        :uuid="uuid"
        @confirm="handleConfirmClick"
        @import="handleImportAllClick"
        @close="showDialog = false"
      ></LibraryChooseDialog>
    </div>
    <input
      type="file"
      ref="uploadImage"
      accept="image/*"
      multiple
      limit="2"
      style="display: none"
      @change="handleImageFileChange"
    />
    <input
      type="file"
      ref="uploadVideo"
      accept="video/*"
      style="display: none"
      @change="handleVideoFileChange"
    />

    <!-- 微信绑定弹窗 -->
    <el-dialog
      title="绑定微信"
      :visible.sync="wxBindDialogVisible"
      width="400px"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="wx-bind-dialog">
        <p>请扫码绑定微信后继续</p>
        <div class="qr-code-container">
          <img ref="xcxqrcode" :src="qrCodeUrl" alt="微信二维码" v-if="qrCodeUrl" />
          <div v-else class="loading">加载中...</div>
        </div>
        <p class="message">{{ message }}</p>
        <div ref="wrpreloadbtn" class="reload-btn" v-if="message">
          <el-button type="primary" size="small" @click="getWxQrCode">重新获取</el-button>
        </div>
      </div>
    </el-dialog>

  </div>


</template>
<script>
import draggable from "vuedraggable";
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";
import QuestionEditSCQ from "@/components/QuestionEdit/QuestionEditSCQ.vue";
import QuestionEditMCQ from "@/components/QuestionEdit/QuestionEditMCQ.vue";
import QuestionEditDLQ from "@/components/QuestionEdit/QuestionEditDLQ.vue";
import QuestionEditVote from "@/components/QuestionEdit/QuestionEditVote.vue";
import QuestionEditSort from "@/components/QuestionEdit/QuestionEditSort.vue";
import QuestionEditSBQ from "@/components/QuestionEdit/QuestionEditSBQ.vue";
import QuestionEditMBQ from "@/components/QuestionEdit/QuestionEditMBQ.vue";
import QuestionEditQA from "@/components/QuestionEdit/QuestionEditQA.vue";
import QuestionEditGender from "@/components/QuestionEdit/QuestionEditGender.vue";
import QuestionEditAge from "@/components/QuestionEdit/QuestionEditAge.vue";
import QuestionEditNPS from "@/components/QuestionEdit/QuestionEditNPS.vue";
import QuestionEditRemark from "@/components/QuestionEdit/QuestionEditRemark.vue";
import QuestionEditScore from "@/components/QuestionEdit/QuestionEditScore.vue";
import QuestionEditName from "@/components/QuestionEdit/QuestionEditName.vue";
import QuestionEditEmail from "@/components/QuestionEdit/QuestionEditEmail.vue";
import QuestionEditTel from "@/components/QuestionEdit/QuestionEditTel.vue";
import QuestionEditTime from "@/components/QuestionEdit/QuestionEditTime.vue";
import QuestionEditDate from "@/components/QuestionEdit/QuestionEditDate.vue";
import QuestionEditWRQ from "@/components/QuestionEdit/QuestionEditWRQ.vue";
import QuestionEditSRQ from "@/components/QuestionEdit/QuestionEditSRQ.vue";
import QuestionEditAddress from "@/components/QuestionEdit/QuestionEditAddress.vue";
import QuestionEditImage from "@/components/QuestionEdit/QuestionEditImage.vue";
import QuestionEditMaxDiff from "@/components/QuestionEdit/QuestionEditMaxDiff.vue";
import QuestionEditUploadFile from "@/components/QuestionEdit/QuestionEditUploadFile.vue";
import QuestionEditDownloadFile from "@/components/QuestionEdit/QuestionEditDownloadFile.vue";
import QuestionEditCASCADER from "@/components/QuestionEdit/QuestionEditCASCADER.vue";
import QuestionEditBDQ from "@/components/QuestionEdit/QuestionEditBDQ.vue";
import QuestionEditIDQ from "@/components/QuestionEdit/QuestionEditIDQ.vue";
import QuestionEditELQ from "@/components/QuestionEdit/QuestionEditELQ.vue";
import QuestionEditWX from "@/components/QuestionEdit/QuestionEditWX.vue";

import QuestionPreviewSCQ from "@/components/QuestionPreview/QuestionPreviewSCQ.vue";
import QuestionPreviewMCQ from "@/components/QuestionPreview/QuestionPreviewMCQ.vue";
import QuestionPreviewDLQ from "@/components/QuestionPreview/QuestionPreviewDLQ.vue";
import QuestionPreviewVote from "@/components/QuestionPreview/QuestionPreviewVote.vue";
import QuestionPreviewSort from "@/components/QuestionPreview/QuestionPreviewSort.vue";
import QuestionPreviewSBQ from "@/components/QuestionPreview/QuestionPreviewSBQ.vue";
import QuestionPreviewMBQ from "@/components/QuestionPreview/QuestionPreviewMBQ.vue";
import QuestionPreviewQA from "@/components/QuestionPreview/QuestionPreviewQA.vue";
import QuestionPreviewGender from "@/components/QuestionPreview/QuestionPreviewGender.vue";
import QuestionPreviewAge from "@/components/QuestionPreview/QuestionPreviewAge.vue";
import QuestionPreviewNPS from "@/components/QuestionPreview/QuestionPreviewNPS.vue";
import QuestionPreviewRemark from "@/components/QuestionPreview/QuestionPreviewRemark.vue";
import QuestionPreviewScore from "@/components/QuestionPreview/QuestionPreviewScore.vue";
import QuestionPreviewName from "@/components/QuestionPreview/QuestionPreviewName.vue";
import QuestionPreviewEmail from "@/components/QuestionPreview/QuestionPreviewEmail.vue";
import QuestionPreviewTel from "@/components/QuestionPreview/QuestionPreviewTel.vue";
import QuestionPreviewTime from "@/components/QuestionPreview/QuestionPreviewTime.vue";
import QuestionPreviewDate from "@/components/QuestionPreview/QuestionPreviewDate.vue";
import QuestionPreviewWRQ from "@/components/QuestionPreview/QuestionPreviewWRQ.vue";
import QuestionPreviewSRQ from "@/components/QuestionPreview/QuestionPreviewSRQ.vue";
import QuestionPreviewAddress from "@/components/QuestionPreview/QuestionPreviewAddress.vue";
import QuestionPreviewImage from "@/components/QuestionPreview/QuestionPreviewImage.vue";
import QuestionPreviewMaxDiff from "@/components/QuestionPreview/QuestionPreviewMaxDiff.vue";
import QuestionPreviewUploadFile from "@/components/QuestionPreview/QuestionPreviewUploadFile.vue";
import QuestionPreviewDownloadFile from "@/components/QuestionPreview/QuestionPreviewDownloadFile.vue";
import QuestionPreviewCASCADER from "@/components/QuestionPreview/QuestionPreviewCASCADER.vue";
import QuestionPreviewBDQ from "@/components/QuestionPreview/QuestionPreviewBDQ.vue";
import QuestionPreviewIDQ from "@/components/QuestionPreview/QuestionPreviewIDQ.vue";
import QuestionPreviewELQ from "@/components/QuestionPreview/QuestionPreviewELQ.vue";
import QuestionPreviewWX from "@/components/QuestionPreview/QuestionPreviewWX.vue";

import CustomLogin from "@/components/CustomLogin/CustomLogin.vue";
import QuestionStartAndEnd from "@/components/QuestionStartAndEnd/QuestionStartAndEnd.vue";
import LibraryChooseDialog from "@/components/LibraryChooseDialog/index.vue";
import ConsentRequiredDialog from "@/components/ConsentRequiredDialog/index.vue";
import ShareImageDialog from "@/components/ShareImageDialog/index.vue";

import {
  getUuid,
  createQuestionnaire,
  updateQuestionnaire,
  setQuestion,
  questionTempList,
  questionnaireUpdateDetail,
  removeQuestionnaire,
  saveQuestion,
  getThemeList,
  addQuestionToQuestionnaire,
  feiShuBindUser
} from "@/api/index.js";
// import QuestionType from "@/common/index.js";

export default {
  components: {
    draggable,
    QuestionEditSCQ,
    QuestionEditDLQ,
    QuestionEditVote,
    QuestionEditSort,
    QuestionEditSBQ,
    QuestionEditMBQ,
    QuestionEditQA,
    QuestionEditGender,
    QuestionEditAge,
    QuestionEditNPS,
    QuestionEditRemark,
    QuestionEditScore,
    QuestionEditName,
    QuestionEditEmail,
    QuestionEditTel,
    QuestionEditTime,
    QuestionEditDate,
    QuestionEditWRQ,
    QuestionEditSRQ,
    QuestionEditMCQ,
    QuestionEditAddress,
    QuestionEditImage,
	QuestionEditMaxDiff,
	QuestionEditUploadFile,
	QuestionEditDownloadFile,
	QuestionEditCASCADER,
	QuestionEditBDQ,
	QuestionEditIDQ,
	QuestionEditELQ,
	QuestionEditWX,
    QuestionPreviewSCQ,
    QuestionPreviewDLQ,
    QuestionPreviewVote,
    QuestionPreviewSort,
    QuestionPreviewSBQ,
    QuestionPreviewMBQ,
    QuestionPreviewQA,
    QuestionPreviewGender,
    QuestionPreviewAge,
    QuestionPreviewNPS,
    QuestionPreviewRemark,
    QuestionPreviewScore,
    QuestionPreviewName,
    QuestionPreviewEmail,
    QuestionPreviewTel,
    QuestionPreviewTime,
    QuestionPreviewDate,
    QuestionPreviewWRQ,
    QuestionPreviewSRQ,
    QuestionPreviewMCQ,
    QuestionPreviewAddress,
    QuestionPreviewImage,
	QuestionPreviewMaxDiff,
	QuestionPreviewUploadFile,
	QuestionPreviewDownloadFile,
	QuestionPreviewCASCADER,
	QuestionPreviewBDQ,
	QuestionPreviewIDQ,
	QuestionPreviewELQ,
	QuestionPreviewWX,
    CustomLogin,
    QuestionStartAndEnd,
    LibraryChooseDialog,
	ConsentRequiredDialog,
	ShareImageDialog
  },
  data() {
    return {
      uuid: "",
      components: [
        { type: 1, name: "单选" },
        { type: 2, name: "多选" },
        { type: 3, name: "填空" },
        { type: 4, name: "多项填空" },
        { type: 5, name: "下拉" },
        { type: 6, name: "NPS" },
        { type: 7, name: "投票" },
        { type: 8, name: "排序" },
        { type: 9, name: "备注说明" },
        { type: 10, name: "分数评定" },
        { type: 11, name: "问答" },
        { type: 12, name: "权重评分" },
        { type: 13, name: "评星" },
        { type: 23, name: "图片上传" },
		{ type: 24, name: "MaxDiff" },
		{ type: 25, name: "上传文件" },
		{ type: 26, name: "下载附件" },
		{ type: 27, name: "联级题" },
        { type: 14, name: "姓名" },
        { type: 15, name: "性别" },
        { type: 16, name: "年龄" },
        { type: 17, name: "电话号" },
        { type: 18, name: "邮箱" },
        { type: 19, name: "日期" },
        { type: 20, name: "时间" },
        { type: 21, name: "地址" },
        { type: 29, name: "出生日期" },
        { type: 30, name: "身份证号" },
        { type: 31, name: "学历" },
        { type: 32, name: "微信号" },
      ],
      QuestionType: this.$store.getters['question/getQuestionType'],
      formItems: [],
      selectedIndex: null,
      // 微信绑定弹窗相关
      wxBindDialogVisible: false,
      qrCodeUrl: "",
      loginKey: "",
      pollingInterval: null,
      message: "",
      token: "",
      dataObj: {
        questionnaireName: "", // 问卷名称
        questionnaireDescribe: "", // 问卷描述
        questionnaireInformation: JSON.stringify([]), // 问卷信息
        ifFrontPage: 0, //  是否开始答题/问卷结束设置 0不设置 1设置
        startLanguage: "感谢您的参与", // 问卷开始语
        endLanguage: "感谢您的参与", // 问卷结束语
        endImg:
          "https://ossfastmake.mustke.com/qrCode/tupian/1737534281905.png", // 问卷结束图片
        startImg:
          "https://ossfastmake.mustke.com/qrCode/tupian/1737534281905.png", // 问卷开始图片
        startSubtitle: "", // 问卷开始小标题
        startButtonText: "开始答题", // 问卷开始按钮文本
        startButtonColor: "#FF4F4F", // 问卷开始按钮颜色
        startColor: "#1D4AC3", // 问卷开始主题颜色
        endColor: "#1D4AC3", // 问卷结束主题颜色
        startLittleImg: "", // 问卷开始小图片
        endLittleImg: "", // 问卷结束小图片
        startColorBegin: "", // 问卷开始主题颜色
        endColorBegin: "", // 问卷结束主题颜色
        startColorEnd: "", // 问卷开始主题颜色
        endColorEnd: "", // 问卷结束主题颜色
        startThemeColor: "", // 问卷开始主题颜色
        endThemeColor: "", // 问卷结束主题颜色
        startTextColor: "", // 问卷开始文本颜色
        endTextColor: "", // 问卷结束文本颜色
        ifOneChance: "1", // 每人只能回答一次(仅限小程序生效) 0不设置 1设置
        ifShowCreator: "0", // 显示创建者 0不设置 1设置
        ifShowParticipation: "0", // 显示参与人数 0不设置 1设置
        ifShowCreateTime: "0", // 显示创建时间 0不设置 1设置
        ifRecyclingReminder: "0", // 问卷回收题提醒 0不设置 1设置
        ifShare: "0", // 仅创建人可分享 0不设置 1设置
        creatorName: localStorage.getItem("nickname"), // 创建人
        themeId: "", // 主题id
        yzTheme: {
          borderColor: "#E3E3E3",
          startColor: "#ffffff",
          endColor: "#ffffff",
          mainTitle: "默认主题",
          subTitle: "默认主题",
          mainColor: "#333333",
          subColor: "#333333",
          btnColor: "#333333",
          btnText: "提交",
          btnBg: "#ffffff",
          btnBorder: "#E3E3E3",
          themeColor: "#3A60FF",
        }, // 主题数据
        ifForever: "0", // 是否设置开始时间结束时间  0否 1是
        startTime: new Date().getTime(), // 问卷开始时间
        endTime: new Date().getTime() + 7 * 24 * 60 * 60 * 1000, // 问卷结束时间
        ifCustomLogin: "0", // 是否设置自定义登录(独立登录) 0不设置 1设置
		consentRequired: "0", // 知情同意书 0不设置 1设置
		consentContent: '感谢您考虑参与我们的调查问卷。这份问卷旨在收集关于XXX主题的重要信息，以帮助我们更好地理解这一领域。您的参与对于我们的研究至关重要。在您开始之前，我们希望您了解以下事项:\n'+ '1.目的与保密性: 此调查的目的在于收集关于XXX主题的数据。您的个人信息(包括姓名和联系方式)将严格保密，只用于统计分析，并在报告中以匿名方式星现。\n'+ '2.自愿参与: 您的参与是完全自愿的。如果您在任何时候决定退出调查，都可以自由地停止回答问题,数据保护: 我们将采取所有必要的安全措施来保护您的个人信息。数据将被存储在受密码保护的系统中，并且只有经过授权的人员可以访问。',
        customLoginSettingList: [
          {
            type: 1, // 1题头 2头像 3填空 4下拉
            content: JSON.stringify({
              popTitle: "快速登录",
              popSmallTitle: "请正确填写下面信息",
            }),
          },
          {
            type: 2,
            content: JSON.stringify({
              headTitle: "头像",
              headSmallTitle: "点击上传头像",
              imageUrl:
                "https://ossfastmake.mustke.com/qrCode/tupian/1750303449766.svg",
            }),
          },
          {
            type: 3,
            content: JSON.stringify({
              label: "姓名",
              value: "",
              type: 0,
            }),
          },
        ],
        buildStatus: 0, // 生成状态 0保存草稿  1生成问卷
		shareImgId: null, // 分享图片id
		shareImgUrl: 'https://ossfastmake.mustke.com/wenjuan/tupian/shareBack2-1744791138873.jpg', // 分享图片url
      },
      infoFileList: [],
      addQuestionsList: [],
      choiceOfId: "",
      /* 点击的是不是可编辑区域右上角的按钮 */
      isAbilityBtn: false,
      // 编辑器内的 图片定位
      positionInfo: {
        top: 100,
        left: 100,
        show: false,
      },
      // 是否显示选项按钮
      showOptionBtn: [1, 2, 12, 14, 15],
      // 是否显示其他选项按钮
      showOtherOptionBtn: [1, 2, 12, 14, 15],
      Starstyle_arr: ["五角星", "爱心", "笑脸", "点赞"],
      // 评分题数量设置 数组
      scoreArr: [2, 3, 4, 5, 6, 7, 8, 9, 10],
      // 评分题起始值设置 数组
      startScoreArr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      Type: null,
      operate: "创建",
      id: null,
      loading: null,
      showThemeSetting: false,
      selectThemeIndex: 0,
      themeList: [],
      showCoverSetting: false,
      showLoginSetting: false,
	  showConsentRequired: false,
	  showShareImage: false,
      themeData: {},
      showDialog: false,
      uploadFileIndex: -1,
      nameFocus: false,
      descFocus: false,
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    if (this.id && this.id.trim() !== "") {
      if (this.$route.query.type === "template") {
        this.operate = "创建";
      } else {
        this.operate = "编辑";
      }
      this.uuid = this.id;
      this.queryDetail();
    } else {
      this.getUuidParams();
    }

    this.queryQuestionTempList();

    console.log("QuestionType1111111111111", this.QuestionType);
    
  },
  created() {

    console.log("接收到的 ID：", this.$route.query.id);
    this.uuid = this.$route.query.id;
    this.dataObj.questionnaireName = this.$route.query.title
      ? this.$route.query.title
      : "";
    this.dataObj.questionnaireDescribe = this.$route.query.content
      ? this.$route.query.content
      : "";
    this.themeData = this.dataObj.yzTheme;
    getThemeList()
      .then((res) => {
        console.log(res, "pppppppppppppppppp");

        this.themeList = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  // 组件定义同方案一
  methods: {
    async getUuidParams() {
      await getUuid()
        .then((res) => {
          if (res.code === 200) {
            this.uuid = res.data;
          } else {
            this.$message.closeAll();
            this.$message({
              type: "error",
              message: res.message,
              offset: "150",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    saveClick(item, index) {
      this.queryQuestionTempList();
    },
    cancelClick() {},
    selectItem(index) {
      this.selectedIndex = index;
    },
    handleComponentClick(item, index) {
      // const hasEdit = this.addQuestionsList.some((item) => item.status === "0");
      // if (hasEdit) {
      //   this.$message.closeAll();
      //   this.$message({
      //     type: "error",
      //     message: "请先保存当前编辑的题目",
      //     offset: "150",
      //   });
      //   return;
      // }
      this.$message.closeAll();
      const activeItem = this.addQuestionsList.find(item => item.status === '0');
      console.log("activeItem=====handleComponentClick", activeItem);
      if (activeItem !== undefined && activeItem !== null && activeItem !== {}) {
        const checkItem = this.checkQuestion(activeItem);
        checkItem.uuid = this.uuid;

      // 检查localStorage中是否存在openId
      const openId = localStorage.getItem('openId');
      if (openId == null || openId == "null" || openId == undefined || openId == "") {

        if(this.wxBindDialogVisible == false){
          // 显示微信绑定弹窗
          this.wxBindDialogVisible = true;
          // 获取二维码
          this.getWxQrCode();
        }

        return;
      }

        saveQuestion(checkItem)
          .then((res) => {
            console.log(res);
            if (res.code == 200) {
              // this.queryQuestionTempList();
              activeItem.status = '1';
            } else {
              this.$message({
                type: "error",
                message: res.msg,
                offset: "150",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      console.log('item', item, index);
	  console.log('this.QuestionType', this.QuestionType)
      switch (item.type) {
        case this.QuestionType.SCQ:
          this.addQuestionsList.push({
            type: 1,
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                  jump_title: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  jump_title: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  jump_title: "",
                },
              ],
              count: 1, //单选多选
            }),
            status: "0", // 0创建页编辑中 1创建页显示操作 2创建页预览 3详情页预览 4详情页答题
          });
          break;
        case this.QuestionType.MCQ:
          this.addQuestionsList.push({
            type: 2,
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              maxCount: 2,
              minCount: 1,
              isCountMust: 0,
              isCountSwitch: 0,
            }),
            status: "0",
          });
          break;
        case this.QuestionType.SBQ:
          this.addQuestionsList.push({
            type: 3,
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            fillSymbol: 3, // 填空符数量
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            status: "0",
          });
          break;
        case this.QuestionType.MBQ:
          this.addQuestionsList.push({
            type: 4, // 分数评定类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  img_path: [],
                },
                {
                  text: "",
                  img_path: [],
                },
                {
                  text: "",
                  img_path: [],
                },
              ],
            }),
            status: "0",
          });
          break;
        case this.QuestionType.DLQ:
          this.addQuestionsList.push({
            type: 5, // 下拉类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), //题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                },
                {
                  text: "",
                },
                {
                  text: "",
                },
              ],
              value: "",
            }),
            status: "0",
          });
          break;
        case this.QuestionType.NPS:
          this.addQuestionsList.push({
            type: 6, // NPS类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), //题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          });
          break;
        case this.QuestionType.VOTE:
          this.addQuestionsList.push({
            type: 7, // 投票类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            ifShowResult: 0, // 0 不展示 1 展示
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 1, //单选多选
            }),
            status: "0",
          });
          break;
        case this.QuestionType.SORT:
          this.addQuestionsList.push({
            type: 8, // 排序类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: true,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 3, //统一格式的话 有几项就得填几项 前端决定
            }),
            status: "0",
          });
          break;
        case this.QuestionType.REMARK:
          this.addQuestionsList.push({
            type: 9, // 备注类型
            caseProblem: "",
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          });
          break;
        case this.QuestionType.SCORE:
          this.addQuestionsList.push({
            type: 10, // 分数评定类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            minScore: 1, // 起始分数
            scoreNum: 5, // 评分数量
            // elseConfig: JSON.stringify(["非常不满意", "一般", "非常满意"]),
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  ratingArr: ["非常不满意","一般","非常满意"]
                },
              ],
            }),
            status: "0",
          });
          break;
        case this.QuestionType.QA:
          this.addQuestionsList.push({
            type: 11, // 问答题
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          });
          break;
        case this.QuestionType.WRQ:
          this.addQuestionsList.push({
            type: 12, // 权重评分类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", //  逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  score: 1,
                },
                {
                  text: "",
                  score: 1,
                },
                {
                  text: "",
                  score: 1,
                },
              ],
            }),
            status: "0",
          });
          break;
        case this.QuestionType.SRQ:
          this.addQuestionsList.push({
            type: 13, // 评星类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            scoreNum: 5, // 最高分
            starRatingStyle: "1", // 评星样式 前端定 字符串类型
            // elseConfig: JSON.stringify(["非常不满意", "一般", "非常满意"]),
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  ratingArr: ["非常不满意","一般","非常满意"]
                },
              ],
            }),
            status: "0",
          });
          break;
        case this.QuestionType.NAME:
          this.addQuestionsList.push({
            type: 14, // 姓名
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          });
          break;
        case this.QuestionType.GENDER:
          this.addQuestionsList.push({
            type: 15,
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "男",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "女",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 1, //单选多选
            }),
            status: "0",
          });
          break;
        case this.QuestionType.AGE:
          this.addQuestionsList.push({
            type: 16,
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "18岁以下",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "18~35岁",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "35~60岁",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "60岁以上",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 1, //单选多选
            }),
            status: "0",
          });
          break;
        case this.QuestionType.TEL:
          this.addQuestionsList.push({
            type: 17, // 手机号
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            isOnly: 0, // 0 是否唯一  0否 1是
            status: "0",
          });
          break;
        case this.QuestionType.EMAIL:
          this.addQuestionsList.push({
            type: 18, // 邮箱
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          });
          break;
        case this.QuestionType.DATE:
          this.addQuestionsList.push({
            type: 19, // 日期
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          });
          break;
        case this.QuestionType.TIME:
          this.addQuestionsList.push({
            type: 20, // 时间
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          });
          break;
        case this.QuestionType.ADDR:
          this.addQuestionsList.push({
            type: 21, // 地址类型
            caseProblem: "", // 题目
            mapAccuracy: 3, // 0 选择地址精度 1 精确到省 2 精确到市 3 精确到区 4 精确到详细地址
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", //  逻辑设置(question_id)
            status: "0",
          });
          break;
        case this.QuestionType.IMAGE:
          this.addQuestionsList.push({
            type: 23, // 图片上传类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            pictureNum: 6, // 图片数量
            status: "0",
          });
          break;
		case this.QuestionType.MaxDiff:
			this.addQuestionsList.push({
			  type: 24,
			  caseProblem: "请输入题目说明",
			  ifRandomize: 0,
			  caseProblemImg: JSON.stringify([]),
			  isMust: 1,
			  chooseList: JSON.stringify({
			    list: [
			      {
			        id: "1",
			        context: "属性1"
			      },
			      {
			        id: "2",
			        context: "属性2"
			      },
			      {
			        id: "3",
			        context: "属性3"
			      }
			    ],
				tasksNum: 6,
				attributesNum: 3,
				percentageTitle: "满意,不满意",
			    count: 1,
			  }),
			  status: "0",
			});
			break;
		case this.QuestionType.UploadFile:
		  this.addQuestionsList.push({
		    type: 25,
		    caseProblem: "请上传文件",
		    caseProblemImg: JSON.stringify([]),
		    isMust: 1,
		    status: "0",
		  });
		  break;
		case this.QuestionType.DownloadFile:
			this.addQuestionsList.push({
			  type: 26,
			  caseProblem: "请输入题目说明",
			  ifRandomize: 0,
			  caseProblemImg: JSON.stringify([]),
			  isMust: 1,
			  chooseList: JSON.stringify({list: []}),
			  status: "0",
			});
			break;
		case this.QuestionType.CASCADER:
			this.addQuestionsList.push({
			  type: 27,
			  caseProblem: "请输入题目说明",
			  ifRandomize: 0,
			  caseProblemImg: JSON.stringify([]),
			  isMust: 1,
			  chooseList: JSON.stringify({
			    options: [
			      {
			        label: "一级选项",
			        children: [
						{
							label: "二级选项1",
							children: [],
						}
					]
				  }
			    ]
			  }),
			  elseConfig: "一级标题名称,二级标题名称",
			  status: "0",
			});
			break;
		case this.QuestionType.BDQ:
		  this.addQuestionsList.push({
		    type: 29, // 出生日期
		    caseProblem: "", // 题目
		    isMust: 1, // 是否必填  0否 1是
		    logicalJump: "", // 逻辑设置(question_id)
		    status: "0",
		  });
		  break;
		case this.QuestionType.IDQ:
		  this.addQuestionsList.push({
		    type: 30, // 身份证号
		    caseProblem: "", // 题目
		    isMust: 1, // 是否必填  0否 1是
		    logicalJump: "", // 逻辑设置(question_id)
		    status: "0",
		  });
		  break;
		case this.QuestionType.ELQ:
		  this.addQuestionsList.push({
		    type: 31, // 学历
		    caseProblem: "", // 题目
		    ifRandomize: 0, // 是否随机排列   0否 1是
		    caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
		    isMust: 1, // 是否必填  0否 1是
		    logicalJump: "", // 逻辑设置(question_id,下一道题的id)
		    chooseList: JSON.stringify({
		      list: [
		        {
					"text":"初中及以下",
				},
				{
					"text":"高中/中专/技校",
				},
				{
					"text":"大学专科",
				},
				{
					"text":"大学本科",
				},
				{
					"text":"硕士及以上",
				}
		      ]
		    }),
		    status: "0",
		  });
		  break;
		case this.QuestionType.WX:
		  this.addQuestionsList.push({
		    type: 32, // 微信号
		    caseProblem: "", // 题目
		    isMust: 1, // 是否必填  0否 1是
		    logicalJump: "", // 逻辑设置(question_id)
		    status: "0",
		  });
		  break;
        default:
          break;
      }

      console.log(this.addQuestionsList, "qwqeqw21312312312312312");
    },
    createClick(buildStatus) {
      // this.checkRequired()
      const activeItem = this.addQuestionsList.find(item => item.status === '0');
      console.log("activeItem===createClick", activeItem);
      if (activeItem !== undefined && activeItem !== null && activeItem !== {}) {
        this.$message.closeAll();
        const checkItem = this.checkQuestion(activeItem);
        checkItem.uuid = this.uuid;

      // 检查localStorage中是否存在openId
      const openId = localStorage.getItem('openId');
      if (openId == null || openId == "null" || openId == undefined || openId == "") {

        if(this.wxBindDialogVisible == false){
          // 显示微信绑定弹窗
          this.wxBindDialogVisible = true;
          // 获取二维码
          this.getWxQrCode();
        }

        return;
      }

        saveQuestion(checkItem)
          .then((res) => {
            console.log(res);
            if (res.code == 200) {
              // this.queryQuestionTempList();
              activeItem.status = '1';
            } else {
              this.$message({
                type: "error",
                message: res.msg,
                offset: "150",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      for (let i = 0; i < this.infoFileList.length; i++) {
        if (this.infoFileList[i].urls.length === 0) {
          this.$message.closeAll();
          this.$message({
            type: "error",
            message: this.infoFileList[i].type === 2 ? "请上传视频" : "请上传图片",
            offset: "150",
          });
          return;
        }
      }
      if (this.addQuestionsList.length === 0) {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "请先添加考题后，在生成问卷！",
          offset: "150",
        });
        return;
      }
      const hasEdit = this.addQuestionsList.some((item) => item.status === "1");
      if (!hasEdit) {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "请先保存编辑的题目",
          offset: "150",
        });
        return;
      }
      const endTime = new Date(this.dataObj.endTime).getTime();
      const startTime = new Date(this.dataObj.startTime).getTime();

      if (this.dataObj.ifForever === "1") {
        console.log("1e21e21e212312312", endTime, startTime);
        if (startTime === 0 || startTime === "") {
          this.$message.closeAll();
          this.$message({
            type: "error",
            message: "请选择开始时间",
            offset: "150",
          });
          return;
        }
        if (endTime === 0 || endTime === "") {
          this.$message.closeAll();
          this.$message({
            type: "error",
            message: "请选择结束时间",
            offset: "150",
          });
          return;
        }
        if (endTime <= startTime) {
          this.$message.closeAll();
          this.$message({
            type: "error",
            message: "结束时间不能小于开始时间",
            offset: "150",
          });
          return;
        }
      }

      this.dataObj.customLoginSettingList =
        this.dataObj.customLoginSettingList.map((item) => {
          if (typeof item.content != "string") {
            item.content = JSON.stringify(item.content);
          }
          return item;
        });
      console.log(
        this.dataObj.customLoginSettingList,
        "请问ID请问i网球服if武器"
      );

      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (this.operate === "创建") {
        createQuestionnaire({
          uuid: this.uuid, // 活动唯一标识
          questionnaireName: this.dataObj.questionnaireName, // 问卷名称
          questionnaireDescribe: this.dataObj.questionnaireDescribe, // 问卷描述
          questionnaireInformation: JSON.stringify(this.infoFileList), // 问卷信息
          ifFrontPage: this.dataObj.ifFrontPage, //  是否开始答题/问卷结束设置 0不设置 1设置
          startLanguage: this.dataObj.startLanguage, // 问卷开始语
          endLanguage: this.dataObj.endLanguage, // 问卷结束语
          endImg: this.dataObj.endImg, // 问卷结束图片
          endSubtitle: this.dataObj.endSubtitle, // 问卷结束小标题
          startImg: this.dataObj.startImg, // 问卷开始图片
          startSubtitle: this.dataObj.startSubtitle, // 问卷开始小标题
          startButtonText: this.dataObj.startButtonText, // 问卷开始按钮文本
          startButtonColor: this.dataObj.startButtonColor, // 问卷开始按钮颜色
          startColor: this.dataObj.startColor, // 问卷开始主题颜色
          endColor: this.dataObj.endColor, // 问卷结束主题颜色
          startLittleImg: this.dataObj.startLittleImg, // 问卷开始小图
          endLittleImg: this.dataObj.endLittleImg, // 问卷结束小图
          startColorBegin: this.dataObj.startColorBegin,
          startColorEnd: this.dataObj.startColorEnd,
          startThemeColor: this.dataObj.startThemeColor,
          startTextColor: this.dataObj.startTextColor,
          endColorBegin: this.dataObj.endColorBegin,
          endColorEnd: this.dataObj.endColorEnd,
          endThemeColor: this.dataObj.endThemeColor,
          endTextColor: this.dataObj.endTextColor,
          ifOneChance: this.dataObj.ifOneChance, // 每人只能回答一次(仅限小程序生效) 0不设置 1设置
          ifShowCreator: this.dataObj.ifShowCreator, // 显示创建者 0不设置 1设置
          ifShowParticipation: this.dataObj.ifShowParticipation, // 显示参与人数 0不设置 1设置
          ifShowCreateTime: this.dataObj.ifShowCreateTime, // 显示创建时间 0不设置 1设置
          ifRecyclingReminder: this.dataObj.ifRecyclingReminder, // 问卷回收题提醒 0不设置 1设置
          themeId: this.dataObj.themeId, // 主题id
          yzTheme: this.dataObj.yzTheme, // 主题数据
          ifForever: this.dataObj.ifForever, // 问卷是否永久有效 0不设置 1设置,
          ifShare: this.dataObj.ifShare, // 是否分享 0不设置 1设置
          creatorName: this.dataObj.creatorName, // 创建者名称
          startTime: startTime, // 问卷开始时间
          endTime: endTime, // 问卷结束时间
          ifCustomLogin: this.dataObj.ifCustomLogin, // 是否设置自定义登录(问卷实名制) 0不设置 1设置
		  consentRequired: this.dataObj.consentRequired, // 知情同意书 0不设置 1设置
		  shareImgId: this.dataObj.shareImgId,
		  shareImgUrl: this.dataObj.shareImgUrl,
		  consentContent: this.dataObj.consentContent,
          customLoginSettingList: this.dataObj.customLoginSettingList, // 用户自定义登录问题列表
          buildStatus: buildStatus, // 生成状态 0保存草稿  1生成问卷
        })
          .then((res) => {
            if (res.code === 200) {
              this.$message.closeAll();
              this.$message({
                type: "success",
                message: "创建成功",
                offset: "150",
              });
              this.$router.replace({
                name: "MyPage",
              });
            } else {
              this.$message.closeAll();
              this.$message({
                type: "success",
                message: res.msg,
                offset: "150",
              });
            }
            this.loading.close();
          })
          .catch((err) => {
            console.log("err", err);
            this.loading.close();
          });
      } else {
        updateQuestionnaire({
          uuid: this.id, // 活动唯一标识
          questionnaireName: this.dataObj.questionnaireName, // 问卷名称
          questionnaireDescribe: this.dataObj.questionnaireDescribe, // 问卷描述
          questionnaireInformation: JSON.stringify(this.infoFileList), // 问卷信息
          ifFrontPage: this.dataObj.ifFrontPage, //  是否开始答题/问卷结束设置 0不设置 1设置
          startLanguage: this.dataObj.startLanguage, // 问卷开始语
          endLanguage: this.dataObj.endLanguage, // 问卷结束语
          endImg: this.dataObj.endImg, // 问卷结束图片
          endSubtitle: this.dataObj.endSubtitle, // 问卷结束小标题
          startImg: this.dataObj.startImg, // 问卷开始图片
          startSubtitle: this.dataObj.startSubtitle, // 问卷开始小标题
          startButtonText: this.dataObj.startButtonText, // 问卷开始按钮文本
          startButtonColor: this.dataObj.startButtonColor, // 问卷开始按钮颜色
          startColor: this.dataObj.startColor, // 问卷开始主题颜色
          endColor: this.dataObj.endColor, // 问卷结束主题颜色
          startLittleImg: this.dataObj.startLittleImg, // 问卷开始小图
          endLittleImg: this.dataObj.endLittleImg, // 问卷结束小图
          startColorBegin: this.dataObj.startColorBegin,
          startColorEnd: this.dataObj.startColorEnd,
          startThemeColor: this.dataObj.startThemeColor,
          startTextColor: this.dataObj.startTextColor,
          endColorBegin: this.dataObj.endColorBegin,
          endColorEnd: this.dataObj.endColorEnd,
          endThemeColor: this.dataObj.endThemeColor,
          endTextColor: this.dataObj.endTextColor,
          ifOneChance: this.dataObj.ifOneChance, // 每人只能回答一次(仅限小程序生效) 0不设置 1设置
          ifShowCreator: this.dataObj.ifShowCreator, // 显示创建者 0不设置 1设置
          ifShowParticipation: this.dataObj.ifShowParticipation, // 显示参与人数 0不设置 1设置
          ifShowCreateTime: this.dataObj.ifShowCreateTime, // 显示创建时间 0不设置 1设置
          ifRecyclingReminder: this.dataObj.ifRecyclingReminder, // 问卷回收题提醒 0不设置 1设置
          themeId: this.dataObj.themeId, // 主题id
          yzTheme: this.dataObj.yzTheme, // 主题数据
          ifForever: this.dataObj.ifForever, // 问卷是否永久有效 0不设置 1设置,
          ifShare: this.dataObj.ifShare, // 是否分享 0不设置 1设置
          creatorName: this.dataObj.creatorName, // 创建者名称
          startTime: startTime, // 问卷开始时间
          endTime: endTime, // 问卷结束时间
          ifCustomLogin: this.dataObj.ifCustomLogin, // 是否设置自定义登录(问卷实名制) 0不设置 1设置
          consentRequired: this.dataObj.consentRequired, // 知情同意书 0不设置 1设置
          shareImgId: this.dataObj.shareImgId,
          shareImgUrl: this.dataObj.shareImgUrl,
          consentContent: this.dataObj.consentContent,
          customLoginSettingList: this.dataObj.customLoginSettingList, // 用户自定义登录问题列表
          updateType: this.dataObj.updateType, // 修改类型 0普通修改 1限制性修改 2完全修改 3复制问卷
          buildStatus: buildStatus, // 生成状态 0保存草稿  1生成问卷
        })
          .then((res) => {
            if (res.code === 200) {
              this.$message.closeAll();
              this.$message({
                type: "success",
                message: "保存成功",
                offset: "150",
              });
              this.$router.replace({
                name: "MyPage",
              });
            } else {
              this.$message.closeAll();
              this.$message({
                type: "success",
                message: res.msg,
                offset: "150",
              });
            }
            this.loading.close();
          })
          .catch((err) => {
            console.log("err", err);
            this.loading.close();
          });
      }
    },
    checkRequired() {
      for (let i = 0; i < this.addQuestionsList.length; i++) {
        const element = this.addQuestionsList[i];
        switch (element.type) {
          case this.QuestionType.SCQ:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.MCQ:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.SBQ:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请输入";
            }
            break;
          case this.QuestionType.MBQ:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请输入";
            }
            break;
          case this.QuestionType.DLQ:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.NPS:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.VOTE:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.SORT:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.REMARK:
            break;
          case this.QuestionType.SCORE:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请输入";
            }
            break;
          case this.QuestionType.QA:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.WRQ:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.SRQ:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请评星";
            }
            break;
          case this.QuestionType.NAME:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请输入";
            }
            break;
          case this.QuestionType.GENDER:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.AGE:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.TEL:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请输入";
            }
            break;
          case this.QuestionType.EMAIL:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请输入";
            }
            break;
          case this.QuestionType.DATE:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.TIME:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.ADDR:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          default:
            break;
        }
      }
    },
    editClick(item, index) {
      const hasEdit = this.addQuestionsList.some((item) => item.status === "0");
      if (hasEdit) {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "请先保存当前编辑的题目",
          offset: "150",
        });
        return;
      }
      this.addQuestionsList[index].status = "0";
    },
    async queryDetail() {
      await questionnaireUpdateDetail({
        uuid: this.uuid,
      })
        .then((res) => {
          if (res.code === 200) {
            console.log("res111111111111111", res);
            
            this.dataObj = res.data;
            this.releaseStatus = res.data.releaseStatus;
            if (this.dataObj.themeId === "" || this.dataObj.themeId === null) {
              this.dataObj.yzTheme = {
                borderColor: "#E3E3E3",
                startColor: "#ffffff",
                endColor: "#ffffff",
                mainTitle: "默认主题",
                subTitle: "默认主题",
                mainColor: "#333333",
                subColor: "#333333",
                btnColor: "#333333",
                btnText: "提交",
                btnBg: "#ffffff",
                btnBorder: "#E3E3E3",
                themeColor: "#3A60FF",
              };
            } else {
              this.selectThemeIndex = this.themeList.findIndex(
                (item) => item.id === this.dataObj.themeId
              );
            }
            this.themeStyle = this.dataObj.yzTheme;
            this.updateType = this.dataObj.updateType;
            this.themeData = this.dataObj.yzTheme;
            console.log("this.dataObj", this.dataObj);

            this.infoFileList = JSON.parse(
              this.dataObj.questionnaireInformation
            );

            console.log("this.infoFileList", this.infoFileList);

            this.queryQuestionTempList();
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    async queryQuestionTempList() {
      await questionTempList({
        uuid: this.uuid, // 活动唯一标识
        predivStatus: 0,
      })
        .then((res) => {
          if (res.code === 200) {
            this.addQuestionsList = res.data;
            this.addQuestionsList.forEach((element) => {
              element.status = "1";
            });
          }
          this.loading.close();
        })
        .catch((err) => {
          this.loading.close();
          console.log("err", err);
        });
    },
    handleThemeSetting() {
      this.showThemeSetting = true;
    },
    // handleThemeSettingClick(item, index) {
    // 	console.log("wqee2e12e12e12e12e", item, index);

    // 	this.selectThemeIndex = index
    // },
    themeSettingConfirmClick(e) {
      console.log("e", this.themeList[this.selectThemeIndex]);

      this.showThemeSetting = false;
      this.dataObj.themeId = this.themeList[this.selectThemeIndex].id;
      this.themeData = this.themeList[this.selectThemeIndex];
	  setTimeout(() => {
			this.$message({
		   type: "success",
		   message: "保存成功",
		   offset: "150",
			});
	  }, 50)
    },
    handleCoverSetting() {
      this.showCoverSetting = true;
    },
    handleLoginSetting() {
      this.showLoginSetting = true;
    },
	handleConsentRequired() {
	  this.showConsentRequired = true;
	},
	handleShareImage() {
		this.showShareImage = true;
	},
    handleCustomLoginChange(e) {
      console.log("e", e);
      this.dataObj.customLoginSettingList = JSON.parse(e).info;
      this.dataObj.ifCustomLogin = JSON.parse(e).ifCustomLogin;
      this.showLoginSetting = false;
	  setTimeout(() => {
		this.$message({
			type: "success",
			message: "保存成功",
			offset: "150",
		});
	  }, 50)
    },
    handleStartEndChange(res) {
      console.log("res", res);
      this.dataObj.startLanguage = res.startLanguage; // 问卷开始语
      this.dataObj.endLanguage = res.endLanguage; // 问卷结束语
      this.dataObj.endImg = res.endImg; // 问卷结束图片
      this.dataObj.startImg = res.startImg; // 问卷开始图片
      this.dataObj.startSubtitle = res.startSubtitle; // 问卷开始小标题
      this.dataObj.startButtonText = res.startButtonText; // 问卷开始按钮文本
      this.dataObj.startButtonColor = res.startButtonColor; // 问卷开始按钮颜色
      this.dataObj.startColor = res.startColor; // 问卷开始主题颜色
      this.dataObj.endColor = res.endColor; // 问卷结束主题颜色
      this.dataObj.endSubtitle = res.endSubtitle; // 问卷结束小标题
      this.dataObj.ifFrontPage = res.ifFrontPage; // 是否开始答题/问卷结束设置 0不设置 1设置
      this.dataObj.startLittleImg = res.startLittleImg; // 问卷开始小图片
      this.dataObj.endLittleImg = res.endLittleImg; // 问卷结束小图片
      this.dataObj.startColorBegin = res.startColorBegin;
      this.dataObj.endColorBegin = res.endColorBegin;
      this.dataObj.startColorEnd = res.startColorEnd;
      this.dataObj.endColorEnd = res.endColorEnd;
      this.dataObj.startThemeColor = res.startThemeColor;
      this.dataObj.endThemeColor = res.endThemeColor;
      this.dataObj.startTextColor = res.startTextColor;
      this.dataObj.endTextColor = res.endTextColor;
      this.showCoverSetting = false;
	  setTimeout(() => {
		this.$message({
			type: "success",
			message: "保存成功",
			offset: "150",
		});
	  }, 50)
    },

    saveQuestionClick(e) {
      console.log("saveQuestionClick", e);
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var data = JSON.parse(e).data;
      data.uuid = this.uuid;

      // 检查localStorage中是否存在openId
      const openId = localStorage.getItem('openId');
      if (openId == null || openId == "null" || openId == undefined || openId == "") {

        if(this.wxBindDialogVisible == false){
          // 显示微信绑定弹窗
          this.wxBindDialogVisible = true;
          // 获取二维码
          this.getWxQrCode();
        }

        return;
      }

      saveQuestion(data)
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.queryQuestionTempList();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
              offset: "150",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateQuestionClick(e) {
      console.log("updateQuestionClick11111111111", e);
      this.addQuestionsList[JSON.parse(e).index] = JSON.parse(e).data;
    },
    cancelQuestionClick(e) {
      console.log("cancelQuestionClick", e);
    },
    logicSettingClick(item, index) {
      console.log("logicSettingClick", item, index);
    },
    handleMaskClick(index) {
      console.log("handleMaskClick", index);
      // const hasEdit = this.addQuestionsList.some((item) => item.status === "0");
      // if (hasEdit) {
      //   this.$message.closeAll();
      //   this.$message({
      //     type: "error",
      //     message: "请先保存当前编辑的题目",
      //     offset: "150",
      //   });
      //   return;
      // }
      this.$message.closeAll();
      const activeItem = this.addQuestionsList.find(item => item.status === '0');
      console.log("activeItem=====handleMaskClick", activeItem);
      if (activeItem !== undefined && activeItem !== null && activeItem !== {}) {
        const checkItem = this.checkQuestion(activeItem);
        checkItem.uuid = this.uuid;


      // 检查localStorage中是否存在openId
      const openId = localStorage.getItem('openId');
      if (openId == null || openId == "null" || openId == undefined || openId == "") {

        if(this.wxBindDialogVisible == false){
          // 显示微信绑定弹窗
          this.wxBindDialogVisible = true;
          // 获取二维码
          this.getWxQrCode();
        }

        return;
      }

        saveQuestion(checkItem)
          .then((res) => {
            console.log(res);
            if (res.code == 200) {
              // this.queryQuestionTempList();
              activeItem.status = '1';
            } else {
              this.$message({
                type: "error",
                message: res.msg,
                offset: "150",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      this.addQuestionsList[index].status = "0";
    },
    handleOperateClick(e) {
      console.log("handleOperateClick", e);
      const type = JSON.parse(e).type;
      const index = JSON.parse(e).index;
      switch (type) {
        case 1:
          break;
        case 2:
          this.upClick(index);
          break;
        case 3:
          this.downClick(index);
          break;
        case 4:
          this.deleteClick(this.addQuestionsList[index], index);
          break;
        default:
          break;
      }
    },
    deleteClick(item, index) {
      console.log(item, index, "oe12oe021ei021ei120");
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.addQuestionsList[index].id) {
            setQuestion({
              setType: "delete",
              id: this.addQuestionsList[index].id,
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.closeAll();
                  this.$message({
                    type: "success",
                    offset: "150",
                    message: "删除成功!",
                  });
                  this.addQuestionsList.splice(index, 1);
                  // this.queryQuestionTempList()
                } else {
                  this.$message.closeAll();
                  this.$message({
                    type: "error",
                    message: res.msg,
                    offset: "150",
                  });
                }
              })
              .catch((err) => {
                console.log("err", err);
              });
          } else {
            this.addQuestionsList.splice(index, 1);
            this.$message.closeAll();
            this.$message({
              type: "success",
              offset: "150",
              message: "删除成功!",
            });
          }
        })
        .catch(() => {});
    },
    upClick(index) {
      // const hasEdit = this.addQuestionsList.some((item) => item.status === "0");
      // if (hasEdit) {
      //   this.$message.closeAll();
      //   this.$message({
      //     type: "error",
      //     message: "请先保存当前编辑的题目",
      //     offset: "150",
      //   });
      //   return;
      // }
      if (this.addQuestionsList[index].id) {
        if (index == 0) {
          this.$message.closeAll();
          this.$message({
            type: "error",
            message: "已经是第一条了",
            offset: "150",
          });
        } else {
          this.loading = this.$loading({
            lock: true,
            text: "加载中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          setQuestion({
            setType: "up",
            id: this.addQuestionsList[index].id,
          })
            .then((res) => {
              if (res.code === 200) {
                this.queryQuestionTempList();
              } else {
                this.loading.close();
                this.$message.closeAll();
                this.$message({
                  type: "success",
                  message: res.msg,
                  offset: "150",
                });
              }
            })
            .catch((err) => {
              this.loading.close();
              console.log("err", err);
            });
        }
      } else {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "请先保存",
          offset: "150",
        });
      }
    },
    downClick(index) {
      // const hasEdit = this.addQuestionsList.some((item) => item.status === "0");
      // if (hasEdit) {
      //   this.$message.closeAll();
      //   this.$message({
      //     type: "error",
      //     message: "请先保存当前编辑的题目",
      //     offset: "150",
      //   });
      //   return;
      // }
      if (this.addQuestionsList[index].id) {
        if (index == this.addQuestionsList.length - 1) {
          this.$message.closeAll();
          this.$message({
            type: "error",
            message: "已经是最后一条了",
            offset: "150",
          });
        } else {
          this.loading = this.$loading({
            lock: true,
            text: "加载中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          setQuestion({
            setType: "down",
            id: this.addQuestionsList[index].id,
          })
            .then((res) => {
              if (res.code === 200) {
                this.queryQuestionTempList();
              } else {
                this.loading.close();
                this.$message.closeAll();
                this.$message({
                  type: "success",
                  message: res.msg,
                  offset: "150",
                });
              }
            })
            .catch((err) => {
              this.loading.close();
              console.log("err", err);
            });
        }
      } else {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "请先保存",
          offset: "150",
        });
      }
    },
    handleImportClick() {
      this.showDialog = true;
    },
    handleConfirmClick(rows) {
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      addQuestionToQuestionnaire({
        uuid: this.uuid,
        yzUserQuestionPoolList: rows,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.closeAll();
            this.$message({
              type: "success",
              offset: "150",
              message: "添加成功!",
            });
            this.queryQuestionTempList();
            this.showDialog = false;
          } else {
            this.$message.closeAll();
            this.$message({
              type: "error",
              message: res.msg,
              offset: "150",
            });
          }
        })
        .finally(() => {
          this.loading.close();
        });
      // this.addQuestionsList = [...this.addQuestionsList, ...rows];
    },
    handleImportAllClick() {
      this.$message.closeAll();
      this.queryQuestionTempList();
      this.showDialog = false;
    },
    handleCustomLoginSwitch() {
      console.log(
        "this.dataObj.customLoginSettingList",
        this.dataObj.customLoginSettingList
      );
      if (this.dataObj.customLoginSettingList.length === 0) {
        this.dataObj.customLoginSettingList = [
          {
            type: 1, // 1题头 2头像 3填空 4下拉
            content: JSON.stringify({
              popTitle: "快速登录",
              popSmallTitle: "请正确填写下面信息",
            }),
          },
          {
            type: 2,
            content: JSON.stringify({
              headTitle: "头像",
              headSmallTitle: "点击上传头像",
              imageUrl:
                "https://ossfastmake.mustke.com/qrCode/tupian/1750303449766.svg",
            }),
          },
          {
            type: 3,
            content: JSON.stringify({
              label: "姓名",
              value: "",
              type: 0,
            }),
          },
        ];
      }
    },
    handleUploadAdd(type) {
      this.infoFileList.push({
        type,
        urls: [],
      })
    },
    handleUploadUp(fileIndex) {
      if (fileIndex === 0) {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "已经是第一条了",
          offset: "150",
        });
        return;
      }
      const temp = this.infoFileList[fileIndex];
      this.$set(this.infoFileList, fileIndex, this.infoFileList[fileIndex - 1]);
      this.$set(this.infoFileList, fileIndex - 1, temp);
    },
    handleUploadDown(fileIndex) {
      console.log("e1212e12e12e12e12e12e12e12");
      console.log("this.infoFileList", this.infoFileList);
      if (fileIndex === this.infoFileList.length - 1) {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "已经是最后一条了",
          offset: "150",
        });
        return;
      }
      console.log("fileIndex去去去去去去去去去", fileIndex);
      const temp = this.infoFileList[fileIndex];
      this.$set(this.infoFileList, fileIndex, this.infoFileList[fileIndex + 1]);
      this.$set(this.infoFileList, fileIndex + 1, temp);
    },
    handleUploadDelete(fileIndex) {
      this.infoFileList.splice(fileIndex, 1);
    },
    handleSingleUploadImage(fileIndex) {
      this.uploadFileIndex = fileIndex;
      this.$refs.uploadImage.click();
    },
    handleMultipleUploadImage(fileIndex) {
      this.uploadFileIndex = fileIndex;
      this.$refs.uploadImage.click();
    },
    handleVideoUploadClick(fileIndex) {
      this.uploadFileIndex = fileIndex;
      this.$refs.uploadVideo.click();
    },
    handleImageFileChange(event) {
      console.log("event.target.files", event.target.files);
      const num = this.infoFileList[this.uploadFileIndex].urls.length;
      const type = this.infoFileList[this.uploadFileIndex].type
      if (num + event.target.files.length > 9 && type === 1) {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "最多上传9张图片",
          offset: "150",
        });
        return;
      }
      this.handleUploadFile(event.target.files);
    },
    handleVideoFileChange(event) {
      console.log("event.target.files", event.target.files);
      this.handleUploadFile(event.target.files);
    },
    handleUploadFile(files) {
      const formData = new FormData();
      // "file" 对应后端接收的字段名
      formData.append("uuid", this.uuid);
      for (let i = 0; i < files.length; i++) {
        formData.append("file", files[i]);
      }
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          
          console.log("response.data.urls", response);
          if (response.data.code === 200) {
            this.$message.success("上传成功！");
            console.log("dwihqet1278et1278et8127te8172", response.data.urls.split(','));
            const urls = response.data.urls.split(',');
            if (this.infoFileList[this.uploadFileIndex].type === 1) {
              this.infoFileList[this.uploadFileIndex].urls = this.infoFileList[this.uploadFileIndex].urls.concat(urls.map(item => ({
                url: item,
              })));
            } else {
              this.infoFileList[this.uploadFileIndex].urls = urls.map(item => ({
                url: item,
              }));
            }
          } else {
            this.$message.error("上传失败！");
          }
        })
        .catch((error) => {
          
        });
    },
    handleSingleDelete(fileIndex) {
      this.infoFileList[fileIndex].urls = [];
    },
    handleMultipleDelete(fileIndex, idx) {
      this.infoFileList[fileIndex].urls.splice(idx, 1);
    },
    handleVideoDelete(fileIndex) {
      this.infoFileList[fileIndex].urls = [];
    },
    handleIfShowCreatorChange() {
      this.dataObj.ifShowParticipation = this.dataObj.ifShowCreator
    },
    handleClickOutside() {
      console.log("this.addQuestionsList", this.addQuestionsList);
      this.$message.closeAll();
      const activeItem = this.addQuestionsList.find(item => item.status === '0');
      console.log("activeItem=====handleClickOutside", activeItem);

      if (activeItem !== undefined && activeItem !== null && activeItem !== {}) {
        const checkItem = this.checkQuestion(activeItem);
        checkItem.uuid = this.uuid;  
        this.loading = this.$loading({
          lock: true,
          text: "加载中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

              // 检查localStorage中是否存在openId
      const openId = localStorage.getItem('openId');
      console.log("activeItem=====handleClickOutside======openId", openId);
      if (openId == null || openId == "null" || openId == undefined || openId == "") {

        if(this.wxBindDialogVisible == false){
          // 显示微信绑定弹窗
          this.wxBindDialogVisible = true;
          // 获取二维码
          this.getWxQrCode();
        }
        console.log("activeItem=====handleClickOutside--------openId", openId);
        return;
      }

        saveQuestion(checkItem)
          .then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.queryQuestionTempList();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
                offset: "150",
              });
            }
            this.loading.close();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    checkQuestion(obj) {
      switch (obj.type) {
        case this.QuestionType.SCQ:
          const list1 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list1.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.MCQ:
          const list2 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list2.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
            minCount: JSON.parse(obj.chooseList).minCount,
            maxCount: JSON.parse(obj.chooseList).maxCount,
          });
          return obj;
        case this.QuestionType.SBQ:
          console.log("obj1111111111111111", obj);
          if (obj.caseProblem == "") {
            this.$message({
              type: "error",
              message: "题目不能为空",
              offset: "150",
            });
            return;
          } else if (!obj.caseProblem.includes("____")) {
            this.$message({
              type: "error",
              message: "请插入填空符",
              offset: "150",
            });
            return;
          }
          return obj;
        case this.QuestionType.MBQ:
          const list3 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请填写以下内容" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list3.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? "请输入" : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.DLQ:
          const list4 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list4.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.NPS:
          obj.caseProblem =
            obj.caseProblem === ""
              ? "您向朋友或同事推荐我们的可能性有多大"
              : obj.caseProblem;
          return obj;
        case this.QuestionType.VOTE:
          const list5 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list5.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.SORT:
          const list6 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给以下选项排序" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list6.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.REMARK:
          obj.caseProblem =
            obj.caseProblem === ""
              ? "请阅读本项说明，然后回答问题"
              : obj.caseProblem;
          return obj;
        case this.QuestionType.SCORE:
          const list7 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给本项打分" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list7.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.QA:
          obj.caseProblem =
            obj.caseProblem === "" ? "请填写问答题目" : obj.caseProblem;
          return obj;
        case this.QuestionType.WRQ:
          const list8 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给本项打分" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list8.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `打分项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.SRQ:
          const list9 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给本项打分" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list9.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `打分项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.NAME:
          obj.caseProblem = obj.caseProblem === "" ? "姓名" : obj.caseProblem;
          return obj;
        case this.QuestionType.GENDER:
          const list10 = JSON.parse(obj.chooseList).list;
          obj.caseProblem = obj.caseProblem === "" ? "性别" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list10.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.AGE:
          const list11 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "您的年龄是" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list11.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.TEL:
          obj.caseProblem = obj.caseProblem === "" ? "手机号" : obj.caseProblem;
          return obj;
        case this.QuestionType.EMAIL:
          obj.caseProblem = obj.caseProblem === "" ? "邮箱" : obj.caseProblem;
          return obj;
        case this.QuestionType.DATE:
          obj.caseProblem = obj.caseProblem === "" ? "日期" : obj.caseProblem;
          return obj;
        case this.QuestionType.TIME:
          obj.caseProblem = obj.caseProblem === "" ? "时间" : obj.caseProblem;
          return obj;
        case this.QuestionType.ADDR:
          obj.caseProblem = obj.caseProblem === "" ? "地址" : obj.caseProblem;
          return obj;
        case this.QuestionType.IMAGE:
          obj.caseProblem =
            obj.caseProblem === "" ? "上传图片回答问题" : obj.caseProblem;
          return obj;
		case this.QuestionType.MaxDiff:
		  obj.caseProblem = obj.caseProblem === "" ? "请输入题目" : obj.caseProblem;
		  return obj;
		case this.QuestionType.UploadFile:
		  obj.caseProblem = obj.caseProblem === "" ? "请上传文件" : obj.caseProblem;
		  return obj;
		case this.QuestionType.DownloadFile:
		  obj.caseProblem = obj.caseProblem === "" ? "请输入题目说明" : obj.caseProblem;
		  return obj;
		case this.QuestionType.CASCADER:
		  obj.caseProblem = obj.caseProblem === "" ? "请输入题目说明" : obj.caseProblem;
		  return obj;
		case this.QuestionType.BDQ:
		  obj.caseProblem = obj.caseProblem === "" ? "请选择出生日期" : obj.caseProblem;
		  return obj;
		case this.QuestionType.IDQ:
		  obj.caseProblem = obj.caseProblem === "" ? "请输入身份证号" : obj.caseProblem;
		  return obj;
		case this.QuestionType.ELQ:
		  obj.caseProblem = obj.caseProblem === "" ? "您的最高学历() 包括在读是？" : obj.caseProblem;
		  return obj;
		case this.QuestionType.WX:
		  obj.caseProblem = obj.caseProblem === "" ? "请填写微信号" : obj.caseProblem;
		  return obj;
        default:
          break;
      }
    },
	ConsentRequiredContent(updatedText) {
	  this.dataObj.consentContent = updatedText
	  this.showConsentRequired = false;
	  setTimeout(() => {
		this.$message({
	       type: "success",
	       message: "保存成功",
	       offset: "150",
		});
	  }, 50)
	},
	ConsentRequiredClose() {
	  this.showConsentRequired = false;
	},
	ShareImageContent(val) {
		this.dataObj.shareImgId = val.shareImgId;
		this.dataObj.shareImgUrl = val.shareImgUrl;
		this.showShareImage = false;
		setTimeout(() => {
			this.$message({
				type: "success",
				message: "保存成功",
				offset: "150",
			});
		}, 50)
	},
	ShareImageClose() {
		this.showShareImage = false;
	},
      // 获取微信二维码
      async getWxQrCode() {
      try {
        const params = {
          // 这里添加你需要传递的参数
        };
        const response = await axios.post(
          `${process.env.API_BASE_URL}/PCwj/login`,
          params,
          {
            headers: {
              appId: this.$store.getters.getAppId,
            },
          }
        );
        if (response.data.code === 200) {
          // 将 Base64 数据转换为可以在 img 标签中使用的格式
          this.qrCodeUrl = `data:image/png;base64,${response.data.data.base64}`;
          this.loginKey = response.data.data.loginKey; // 保存 loginKey
          this.message = "";

          // 开始轮询检查登录状态
          this.pollingInterval = setInterval(async () => {
            try {
              const checkResponse = await axios.get(
                `${process.env.API_BASE_URL}/PCwj/checkLoginCode`,
                {
                  params: {
                    loginKey: this.loginKey,
                  },
                },
                {
                  headers: {
                    appId: this.$store.getters.getAppId,
                  },
                }
              );

              if (checkResponse.data.code === 200) {
                // 假设返回 code 200 且特定字段表示登录成功
                if (checkResponse.data.msg != "0") {
                  clearInterval(this.pollingInterval); // 停止轮询
                  console.log("用户已登录");

                  let arr = checkResponse.data.msg.split(",");
                  this.token = arr[1];

                  // 关闭弹窗
                  this.wxBindDialogVisible = false;
                  
                    //绑定微信
                  const formData = new FormData();
                  formData.append("wxToken", this.token);

                  feiShuBindUser(formData)
                    .then((res) => {
                      console.log(res);
                      if (res.code == 200) {
                       // 保存token
                       localStorage.setItem("token", this.token);

                        this.message = "绑定成功";
                        // 绑定成功后，刷新页面或执行其他操作
                        setTimeout(() => {
                          window.location.reload(); // 刷新页面
                        }, 1000); // 1秒后刷新
                      }
                      //  getUserInfo(localStorage.getItem("token"))
                      //   .then((res) => {
                      //       this.nickname = res.data.nickname;
                      //       localStorage.setItem("nickname", res.data.nickname);
                      //     localStorage.setItem("ifFeiShuDocs", res.data.ifFeiShuDocs);
                      //     localStorage.setItem("feishuDocsExpiry", res.data.feishuDocsExpiry);
                      //     localStorage.setItem("openId", res.data.openidId);
                      //   })
                      //   .catch((err) => {
                      //       console.log("err", err);
                      //   })                      
                      // }

                    })                
                  
                }
              } else if (checkResponse.data.code == 500) {
                clearInterval(this.pollingInterval); // 停止轮询
                // 使用 ref 获取 DOM 元素并修改样式
                if (this.$refs.xcxqrcode) {
                  this.$refs.xcxqrcode.style.filter = "blur(5px)";
                }
                if (this.$refs.wrpreloadbtn) {
                  this.$refs.wrpreloadbtn.style.display = "block";
                }
                this.message = "二维码已过期，请重新扫码";
              } else {
                console.error("检查登录状态失败:", checkResponse.data.msg);
              }
            } catch (error) {
              console.error("检查登录状态时出错:", error);
            }
          }, 3000); // 每 3 秒轮询一次
        } else {
          console.error("获取二维码失败:", response.data.msg);
        }
      } catch (error) {
        console.error("获取二维码失败:", error);
      }
    },
    
  beforeDestroy() {
    // 组件销毁时清除轮询
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  },

  },
};
</script>

<style lang="scss" scoped>
.form-builder {
  display: flex;
  height: 100vh;
  font-family: Arial, sans-serif;
}

.components-panel {
  width: 200px;
  padding: 15px;
  border-right: 1px solid #e0e0e0;
  background: #f5f5f5;
}

.component-item {
  padding: 10px;
  margin-bottom: 10px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: move;
  user-select: none;
  transition: all 0.2s;
}

.component-item:hover {
  background: #e6f7ff;
  border-color: #1890ff;
}

.form-area {
  flex: 1;
  padding: 20px;
  min-height: 100%;
  background: #fafafa;
  overflow-y: auto;
}

.form-item {
  position: relative;
  padding: 15px;
  margin-bottom: 15px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  transition: all 0.2s;
}

.form-item.selected {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.remove-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #ff4d4f;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s;
}

.form-item:hover .remove-btn {
  opacity: 1;
}

.property-panel {
  width: 300px;
  padding: 15px;
  border-left: 1px solid #e0e0e0;
  background: white;
}

.property-panel h3 {
  margin-top: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.property-panel label {
  display: block;
  margin: 15px 0 5px;
  font-weight: bold;
  color: #666;
}

.property-panel input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.form-control {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.checkbox,
.radio {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.noData {
  height: 525px;
  background-color: #fff;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.noData .text {
  font-size: 14px;
  font-weight: 400;
  color: rgba(85, 90, 100, 1);
  margin-top: 30px;
}

.switch-div {
  display: flex;
  align-items: center;
}

.switch-div p {
  font-size: 14px;
  font-weight: 400;
  color: #555a64;
}

.switch-div .el-switch {
  margin-left: 10px;
}

.add_title {
  font-size: 18px;
  display: flex;
  justify-content: space-between;
}

.demonstration {
  font-size: 14px;
  font-weight: 400;
  color: #555a64;
}

.questionnaire_box .add_control .add_btn_list .btn_item .content {
  padding: 0;
}

.item-container {
  width: 100%;
  height: calc(100% - 80px);
  padding-top: 25px;
  padding-bottom: 92px;
  overflow: hidden;
  overflow-y: scroll;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px 20px 0px 20px;
  box-sizing: border-box;
}

.btn-div {
  // width: 100%;
  // box-sizing: border-box;
  // display: flex;
  // justify-content: space-between;
  // position: absolute;
  // left: 0;
  // bottom: 0;
  // background: #ffffff;
  // z-index: 200;
  // padding: 25px;
  display: flex;
  justify-content: space-evenly;
  margin-top: 20px;
}

.cancel {
  // flex: 1;
  // height: 66px;
  // line-height: 66px;
  // border-radius: 66px;
  // border: 1px solid #3a60ff;
  // background: #ffffff;
  // font-size: 34px;
  // color: #3a60ff;
  // font-weight: 600;
  // text-align: center;
  width: 134px;
  height: 46.5px;
  line-height: 46.5px;
  color: #3a60ff;
  background-color: #ffffff;
  border: 1px solid #3a60ff;
  font-size: 15px;
  font-weight: 600;
  border-radius: 25px;
  text-align: center;
  cursor: pointer;
}

.confirm {
  // flex: 1;
  // height: 66px;
  // line-height: 66px;
  // border-radius: 66px;
  // border: 1px solid #3a60ff;
  // background: #3a60ff;
  // font-size: 34px;
  // color: #ffffff;
  // font-weight: 600;
  // text-align: center;
  // margin-left: 20px;
  width: 134px;
  height: 46.5px;
  line-height: 46.5px;
  color: #fff;
  background-color: #3a60ff;
  border: 1px solid #3a60ff;
  font-size: 15px;
  font-weight: 600;
  border-radius: 25px;
  text-align: center;
  cursor: pointer;
}

.setting-item {
  height: 51px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 10px 0; */
  border-bottom: 1px solid #e7e7e7;
  transition: opacity 0.3s ease;
  will-change: transform, opacity;
  /* 防止字体加载导致的布局变化 */
  font-display: swap;
  margin-right: 20px;
}

.setting-item-left {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.setting-item-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.setting-title {
  font-weight: 600;
  color: #4c4a56;
  font-size: 15px;
  margin-right: 22px;
  /*margin-left: 14px;*/
}

.setting-subitem {
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(231, 231, 231, 0.5);
  min-width: 150px;
  transition: opacity 0.3s ease;
  will-change: transform, opacity;
  /* 防止字体加载导致的布局变化 */
  font-display: swap;
}

.setting-subtitle {
  font-weight: 600;
  color: #4c4a56;
  font-size: 14px;
  margin-right: 22px;
  flex: 1;
  /*margin-left: 14px;*/
}

.setting-link {
  color: #3a60ff;
  font-size: 14px;
  margin-left: 8px;
}

.bar-view {
  width: 4px;
  height: 15px;
  background-color: #3a60ff;
  margin-right: 10px;
  border-radius: 0 4px 4px 0;
}

.setting-icon {
  width: 10px;
  height: 10px;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(-45deg);
  margin-left: 6px;
}

.mask-div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 100;
}

.create_page {
  height: 100%;
  display: flex;
  justify-content: center;
}

.upload-container {
  width: 100%;
  height: 100%;
  /* padding: 15px; */
  box-sizing: border-box;
}

.upload-btns {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.upload-btns div {
  margin-right: 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.upload-btns div img {
  width: 25px;
  height: 25px;
  margin-right: 5px;
}

.upload-btns div span {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: Regular;
  color: #767d98;
}

.upload-big {
  width: 320px;
  height: 320px;
  background: #ffffff;
  border-radius: 12px;
  font-size: 256px;
  color: #b2b7bf;
  font-weight: 400;
  /* margin-top: 25px; */
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dcdde0;
  margin: 20px auto;
  cursor: pointer;
}

.upload-small {
  width: 185px;
  height: 185px;
  background: #ffffff;
  border-radius: 12px;
  font-size: 256px;
  color: #b2b7bf;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dcdde0;
  cursor: pointer;
  overflow: hidden;
}

.small-image {
  width: 185px;
  height: 185px;
  position: relative;
}

.big-image {
  position: relative;
}

.delete-image {
  width: 20px;
  height: 20px;
  position: absolute;
  top: -5px;
  right: -5px;
  cursor: pointer;
}

.upload-option {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
}

.upload-option img {
  margin-left: 10px;
  margin-top: 15px;
  cursor: pointer;
}

.intro-container {
  width: 100%;
  height: 100%;
  /* padding: 0 15px; */
  /* box-sizing: border-box; */
  margin-top: 15px;
}

.create_head {
  padding: 15px;
  background-color: #fff;
  border-radius: 4px;
}

.bar-span {
  width: 4px;
  height: 16px;
  background: #3a60ff;
  border-radius: 0px 4px 4px 0px;
  margin-left: 2px;
}

.border-div {
  width: 100%;
  height: 0.5px;
  background-color: #e7e7e7;
}

.wx-bind-dialog {
  text-align: center;
}

.qr-code-container {
  margin: 20px 0;
}

.qr-code-container img {
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.loading {
  padding: 50px 0;
  color: #999;
}

.message {
  color: #ff4d4f;
  margin-bottom: 10px;
}

.reload-btn {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/CreatePage/index.vue